// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// import {
//     Wifi,
//     WifiOff,
//     Users,
//     UserCheck,
//     UserX,
//     Clock,
//     AlertCircle,
//     Timer,
//     Coffee,
//     TrendingUp,
//     Calendar,
//     Activity,
//     Monitor,
//     HardDrive,
//     RefreshCw,
//     BarChart2,
//     Wallet,
//     ChartLine,
//     ChartPie
// } from 'lucide-react';
// import {
//     LineChart,
//     Line,
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     Legend,
//     ResponsiveContainer,
//     PieChart,
//     Pie,
//     Cell
// } from 'recharts';

// import { Get_Devices, Get_All_Devices, Get_Org_Devices } from '../../../services/oprations/Device';
// import { Get_Managers_User, Get_Users } from '../../../services/oprations/Users';
// import { Get_Attendance, Get_Attendance_Org } from '../../../services/oprations/Attendance';
// import { Get_Managers } from '../../../services/oprations/Manager';
// import useSocket from '../../../hooks/useSocket'
// import { ACCOUNT_TYPE } from '../../../utils/Account_Type';
// import { GetWalletTracking } from '../../../services/oprations/Bussiness_Logic';
// import { useToast } from '../../Toast';

// const OverviewDashboard = () => {
//     const toast = useToast();
//     const dispatch = useDispatch();
//     const socket = useSocket()
//     const [loading, setLoading] = useState(true);
//     const [initialLoad, setInitialLoad] = useState(true);
//     const token = localStorage.getItem("token");

//     const { user } = useSelector((state) => state.profile)
//     const userDetails = typeof user == 'string' ? JSON.parse(user) : user
//     console.log("profile details...", userDetails)

//     const orgTimezone = userDetails?.timeZone?.value || 'Asia/Calcutta'

//     const toLocalDateKey = (raw) => {
//         if (!raw) return null
//         if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw.trim())) return raw.trim()
//         const d = new Date(raw)
//         if (isNaN(d.getTime())) return null
//         return d.toLocaleDateString('en-CA', { timeZone: orgTimezone })
//     }

//     const getTodayKey = () => new Date().toLocaleDateString('en-CA', { timeZone: orgTimezone })

//     const getCalendarDays = (fromStr, toStr) => {
//         const days = []
//         const todayKey = getTodayKey()
//         const [sy, sm, sd] = fromStr.split('-').map(Number)
//         const [ey, em, ed] = toStr.split('-').map(Number)
//         const start = new Date(sy, sm - 1, sd, 12, 0, 0)
//         const end   = new Date(ey, em - 1, ed, 12, 0, 0)
//         for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
//             const dk = d.toLocaleDateString('en-CA', { timeZone: orgTimezone })
//             if (dk > todayKey) break
//             days.push(dk)
//         }
//         return days
//     }

//     const { devices } = useSelector(state => state.device) || { devices: [] };
//     const { users } = useSelector(state => state.user) || { users: [] };
//     console.log("users", users)
//     const { managers } = useSelector(state => state.manager) || { managers: [] };
//     const { attendance } = useSelector(state => state.Attendance) || { attendance: [] };

//     const attendanceData = React.useMemo(() => {
//         if (!attendance) return [];
//         return typeof attendance === 'string' ? JSON.parse(attendance) : attendance;
//     }, [attendance]);

//     const employeesData = React.useMemo(() => {
//         if (!users) return [];
//         return typeof users === 'string' ? JSON.parse(users) : users;
//     }, [users]);
//     console.log("users...",users)

//     const managersData = React.useMemo(() => {
//         if (!managers) return [];
//         return typeof managers === 'string' ? JSON.parse(managers) : managers;
//     }, [managers]);

//     const devicesData = React.useMemo(() => {
//         if (!devices) return [];
//         return typeof devices === 'string' ? JSON.parse(devices) : devices;
//     }, [devices]);

//     const getCurrentMonthRange = () => {
//         const today = new Date();
//         const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
//         const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);
//         return {
//             from: firstDay.toISOString().split('T')[0],
//             to: new Intl.DateTimeFormat('en-CA', {
//                 timeZone: 'Pacific/Kiritimati',
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit',
//             }).format(today)
//         };
//     };

//     const [dateRange, setDateRange] = useState(getCurrentMonthRange());

//     const [stats, setStats] = useState({
//         devices: { total: 0, online: 0, offline: 0 },
//         employees: { total: 0, active: 0, deactive: 0 },
//         managers: { total: 0, active: 0, deactive: 0 },
//         attendance: { late: 0, earlyOut: 0, present: 0, overtime: 0, total: 0 }
//     });

//     const [attendanceTrend, setAttendanceTrend] = useState([]);
//     const [deviceActivity, setDeviceActivity] = useState([]);
//     const [departmentStats, setDepartmentStats] = useState([]);
//     const [dailyUserStats, setDailyUserStats] = useState([]);

//     // ─── Wallet Balance History ───────────────────────────────────────────────
//     // Reads balance from userDetails.wallet.balance, stores one entry per day
//     // in localStorage keyed by orgId, so the chart fills up day by day.
//     const [walletHistory, setWalletHistory] = useState([]);
//     const [walletHistoryData, setWalletHistoryData] = useState([]);
//     const [walletStats, setWalletStats] = useState({
//         maxBalance: 0,
//         minBalance: 0,
//         avgBalance: 0,
//         totalTransactions: 0,
//         recentTransactions: []
//     });


//     useEffect(() => {
//         const currentBalance = userDetails?.wallet?.balance;
//         if (currentBalance == null) return;

//         const orgId = userDetails?._id || 'default';
//         const storageKey = `wallet_history_${orgId}`;
//         const todayKey = getTodayKey();

//         let history = [];
//         try {
//             const raw = localStorage.getItem(storageKey);
//             history = raw ? JSON.parse(raw) : [];
//         } catch {
//             history = [];
//         }

//         const todayIndex = history.findIndex(h => h.date === todayKey);
//         if (todayIndex === -1) {
//             history = [...history, { date: todayKey, balance: currentBalance }];
//         } else {
//             // Update today's value in case balance changed during the day
//             history[todayIndex] = { date: todayKey, balance: currentBalance };
//         }

//         localStorage.setItem(storageKey, JSON.stringify(history));
//         setWalletHistory(history);
//     }, [userDetails?.wallet?.balance, userDetails?._id]);
//     // ─────────────────────────────────────────────────────────────────────────

//     useEffect(() => {
//         fetchInitialData();
//     }, []);

//     useEffect(() => {
//         if (!socket) return
//         socket.on("Device_Status", (data) => {
//             userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Devices(token)) : dispatch(Get_Org_Devices(token))
//         })
//         return () => {
//             socket.off("Device_Status");
//         };
//     }, [socket, dispatch, token])

//     useEffect(() => {
//         if (!initialLoad && (devicesData.length > 0 || employeesData.length > 0 || managersData.length > 0 || attendanceData.length > 0)) {
//             processDashboardData();
//         }
//     }, [devicesData, employeesData, managersData, attendanceData, initialLoad]);

//     useEffect(() => {
//         if (!initialLoad) {
//             fetchAttendanceData();
//         }
//     }, [dateRange]);

//     useEffect(() => {
//         if (!initialLoad && attendanceData.length > 0) {
//             const trendData = generateTrendData(attendanceData);
//             setAttendanceTrend(trendData);
//         }
//     }, [attendanceData, initialLoad]);

//    const fetchInitialData = async () => {
//         setLoading(true);
//         try {
//             const promises = [
//                 userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Devices(token)) : dispatch(Get_Org_Devices(token)),
//                 userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Managers_User(token)) : dispatch(Get_Users(token)),
//                 userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Attendance('All', dateRange.from, dateRange.to)) : dispatch(Get_Attendance_Org('All', dateRange.from, dateRange.to))
//             ];
//             if (userDetails?.role !== ACCOUNT_TYPE.MANAGER) {
//                 promises.push(dispatch(Get_Managers(token)));
//             }
            
//             await Promise.all(promises);
            
//             // Fetch wallet data separately after initial data loads
//             await fetchWalletBalance(dispatch, setLoading);
            
//             setInitialLoad(false);
//         } catch (error) {
//             console.error("Error fetching dashboard data:", error);
//             setInitialLoad(false);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchAttendanceData = async () => {
//         setLoading(true);
//         try {
//             userDetails?.role == ACCOUNT_TYPE.MANAGER
//                 ? await dispatch(Get_Attendance('All', dateRange.from, dateRange.to))
//                 : await dispatch(Get_Attendance_Org('All', dateRange.from, dateRange.to));
//         } catch (error) {
//             console.error("Error fetching attendance data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const processWalletData = useCallback((walletData, dateRangeFrom, dateRangeTo) => {
//         if (!walletData || !Array.isArray(walletData) || walletData.length === 0) {
//             console.log("No wallet data to process");
//             return [];
//         }

//         console.log("Processing wallet data:", walletData);

//         // Filter data based on date range
//         const filteredData = walletData.filter(item => {
//             if (!item.DateString) return false;
//             const itemDate = new Date(item.DateString).toISOString().split('T')[0];
//             return itemDate >= dateRangeFrom && itemDate <= dateRangeTo;
//         });

//         console.log("Filtered data by date range:", filteredData);

//         // Sort by date (oldest to newest)
//         const sortedData = [...filteredData].sort((a, b) => 
//             new Date(a.DateString) - new Date(b.DateString)
//         );

//         // Format data for chart
//         const chartData = sortedData.map(item => ({
//             date: item.DateString,
//             totalAmount: item.totalamount || 0,
//             subtractAmount: item.subtractamount || 0,
//             totalUsers: item.orgId?.total_users || item.orgId?.totalUsers || 0,
//             orgName: item.orgId?.org_name || item.orgId?.orgName || 'N/A',
//             rawData: item
//         }));

//         // Calculate statistics
//         const balances = chartData.map(d => d.totalAmount);
//         const maxBalance = balances.length > 0 ? Math.max(...balances) : 0;
//         const minBalance = balances.length > 0 ? Math.min(...balances) : 0;
//         const avgBalance = balances.length > 0 ? Math.round(balances.reduce((a, b) => a + b, 0) / balances.length) : 0;
        
//         // Get recent transactions (last 5)
//         const recentTransactions = [...sortedData].reverse().slice(0, 5);

//         setWalletStats({
//             maxBalance,
//             minBalance,
//             avgBalance,
//             totalTransactions: chartData.length,
//             recentTransactions
//         });

//         console.log("Chart data prepared:", chartData);
//         return chartData;
//     }, []);

//     const WalletBalanceTooltip = ({ active, payload, label }) => {
        
//         if (active && payload && payload.length) {
//             const data = payload[0]?.payload;
            
//             if (!data) return null;
            
//             return (
//                 <div style={{ 
//                     backgroundColor: '#1e3a8a', 
//                     border: '1px solid #3b82f6', 
//                     borderRadius: '0.5rem', 
//                     padding: '12px 16px', 
//                     color: 'white', 
//                     fontSize: '13px',
//                     minWidth: '200px'
//                 }}>
//                     <p style={{ marginBottom: 8, fontWeight: 600, color: '#93c5fd', borderBottom: '1px solid #3b82f6', paddingBottom: 4 }}>
//                         {label ? new Date(label).toLocaleDateString("en-IN", { 
//                             day: "2-digit", 
//                             month: "long", 
//                             year: "numeric" 
//                         }) : 'No Date'}
//                     </p>
//                     <p style={{ margin: '4px 0', color: '#60a5fa' }}>
//                         Total Users: <strong>{data.subtractAmount || 0}</strong>
//                     </p>
//                     <p style={{ margin: '4px 0', color: '#f87171' }}>
//                         Subtracted Amount: <strong>-₹{(data.subtractAmount || 0).toLocaleString('en-IN')}</strong>
//                     </p>
//                     <p style={{ margin: '4px 0', color: '#34d399' }}>
//                         Current Balance: <strong>₹{(data.totalAmount || 0).toLocaleString('en-IN')}</strong>
//                     </p>
//                     {data.orgName && data.orgName !== 'N/A' && (
//                         <p style={{ margin: '4px 0', color: '#c084fc', fontSize: '11px', borderTop: '1px solid #3b82f6', marginTop: 6, paddingTop: 4 }}>
//                             Org: {data.orgName}
//                         </p>
//                     )}
//                 </div>
//             );
//         }
//         return null;
//     };

//    const fetchWalletBalance = async () => {
//     try {
//         const res = await dispatch(GetWalletTracking());
//         console.log("wallet tracking...", res);
        
//         // Extract data from response
//         const walletData = res?.data?.data || res?.payload?.data || res;
        
//         if (walletData && Array.isArray(walletData)) {
//             // Filter by date range
//             const filtered = walletData.filter(item => {
//                 const itemDate = item.DateString?.split('T')[0];
//                 return itemDate >= dateRange.from && itemDate <= dateRange.to;
//             });
            
//             // Sort ascending for chart (oldest first)
//             const ascendingData = [...filtered].sort((a, b) => 
//                 new Date(a.DateString) - new Date(b.DateString)
//             );
            
//             // Format for chart (ascending order)
//             const chartData = ascendingData.map(item => ({
//                 date: item.DateString,
//                 totalAmount: item.totalamount,
//                 subtractAmount: item.subtractamount,
//                 totalUsers: item.orgId?.total_users,
//                 orgName: item.orgId?.org_name
//             }));
            
//             setWalletHistoryData(chartData);
            
//             // Sort descending for table (latest first)
//             const descendingData = [...filtered].sort((a, b) => 
//                 new Date(b.DateString) - new Date(a.DateString)
//             );
            
//             // Set recent transactions (already in descending order)
//             setWalletStats({
//                 recentTransactions: descendingData.slice(0, 5)
//             });
//         }
//     } catch (error) {
//         console.error("Error:", error);
//     }
// };

//    useEffect(() => {
//         if (!initialLoad) {
//             fetchWalletBalance();
//         }
//    }, [dateRange, initialLoad]);

//     const processDashboardData = useCallback(() => {
//         const onlineDevices = devicesData.filter(d => d?.last_status === 'ONLINE' || d?.last_status === 'HEARTBEAT').length;
//         const offlineDevices = devicesData.filter(d => d?.last_status === 'OFFLINE').length;
//         const activeEmployees = employeesData.filter(e => e?.status === 'ACTIVE').length;
//         const deactiveEmployees = employeesData.filter(e => e?.status === 'DEACTIVE').length;
//         const activeManagers = managersData.filter(m => m?.status === true).length;
//         const deactiveManagers = managersData.filter(m => m?.status === false).length;

//         const lateCount = attendanceData.filter(a => {
//             const lateMinutes = parseInt(a?.Late_In?.split(':')[0] || '0') * 60 + parseInt(a?.Late_In?.split(':')[1] || '0');
//             return lateMinutes > 0;
//         }).length;

//         const earlyOutCount = attendanceData.filter(a => {
//             const earlyMinutes = parseInt(a?.Erl_Out?.split(':')[0] || '0') * 60 + parseInt(a?.Erl_Out?.split(':')[1] || '0');
//             return earlyMinutes > 0;
//         }).length;

//         const overtimeCount = attendanceData.filter(a => {
//             const overtimeMinutes = parseInt(a?.Over_Time?.split(':')[0] || '0') * 60 + parseInt(a?.Over_Time?.split(':')[1] || '0');
//             return overtimeMinutes > 0;
//         }).length;

//         const presentCount = attendanceData.filter(a => a?.status === 'P').length;
//         const totalEmployees = employeesData.length || 0;

//         setStats({
//             devices: { total: devicesData.length || 0, online: onlineDevices, offline: offlineDevices },
//             employees: { total: totalEmployees, active: activeEmployees, deactive: deactiveEmployees },
//             managers: { total: managersData.length || 0, active: activeManagers, deactive: deactiveManagers },
//             attendance: { late: lateCount, earlyOut: earlyOutCount, present: presentCount, overtime: overtimeCount, total: attendanceData.length || 0 }
//         });

//         const trendData = generateTrendData(attendanceData);
//         setAttendanceTrend(trendData);

//         const deviceActivityData = devicesData.map(device => ({
//             name: device?.device_name || 'Unknown',
//             users: device?.users_count || 0,
//             status: device?.last_status || 'OFFLINE',
//             location: device?.device_location || 'Unknown',
//             last_seen: device?.device_last_seen || new Date().toISOString()
//         }));
//         setDeviceActivity(deviceActivityData);

//         const deptStats = generateDepartmentStats(employeesData, attendanceData);
//         setDepartmentStats(deptStats);

//         const dailyStats = generateDailyUserStats(attendanceData, employeesData);
//         setDailyUserStats(dailyStats);
//     }, [devicesData, employeesData, managersData, attendanceData]);

//     const generateTrendData = (attendance) => {
//         if (!attendance || attendance.length === 0) return [];
//         const dateMap = new Map();
//         const sortedAttendance = [...attendance].sort((a, b) => new Date(a.DateString) - new Date(b.DateString));
//         sortedAttendance.forEach(record => {
//             const date = toLocalDateKey(record.DateString);
//             if (!date) return;
//             if (!dateMap.has(date)) {
//                 dateMap.set(date, { date, present: 0, late: 0, earlyOut: 0, overtime: 0 });
//             }
//             const dayData = dateMap.get(date);
            
//             // Count present
//             if (record.status === 'P') {
//                 dayData.present += 1;
//             }
            
//             // Count late arrivals (if late minutes > 0)
//             const lateMinutes = parseInt(record.Late_In?.split(':')[0] || '0') * 60 + parseInt(record.Late_In?.split(':')[1] || '0');
//             if (lateMinutes > 0) {
//                 dayData.late += 1;
//             }
            
//             // Count early outs (if early minutes > 0)
//             const earlyMinutes = parseInt(record.Erl_Out?.split(':')[0] || '0') * 60 + parseInt(record.Erl_Out?.split(':')[1] || '0');
//             if (earlyMinutes > 0) {
//                 dayData.earlyOut += 1;
//             }
            
//             // Count overtime (if overtime minutes > 0)
//             const overtimeMinutes = parseInt(record.Over_Time?.split(':')[0] || '0') * 60 + parseInt(record.Over_Time?.split(':')[1] || '0');
//             if (overtimeMinutes > 0) {
//                 dayData.overtime += 1;
//             }
//         });
        
//         // Convert to array and sort by date
//         return Array.from(dateMap.values()).sort((a, b) => new Date(a.date) - new Date(b.date));
//     };
//     console.log("dailyuserstat", dailyUserStats)
    
//     const generateDepartmentStats = (employees, attendance) => {
//         if (!employees || employees.length === 0) return [];
//         const deptMap = new Map();
//         employees.forEach(emp => {
//             const dept = emp?.user_department || 'Other';
//             if (!deptMap.has(dept)) {
//                 deptMap.set(dept, { name: dept, total: 0, active: 0, present: 0 });
//             }
//             const deptData = deptMap.get(dept);
//             deptData.total += 1;
//             deptData.active += emp?.status === 'ACTIVE' ? 1 : 0;
//         });
//         if (attendance && attendance.length > 0) {
//             attendance.forEach(record => {
//                 const emp = employees.find(e => e?._id === record?.User_Id);
//                 if (emp) {
//                     const dept = emp?.user_department || 'Other';
//                     const deptData = deptMap.get(dept);
//                     if (deptData && record?.status === 'P') {
//                         deptData.present += 1;
//                     }
//                 }
//             });
//         }
//         return Array.from(deptMap.values());
//     };

//    const generateDailyUserStats = (attendance, employees) => {
//     console.log("attendance data for analysis", attendance)
//     // const totalEmployees = employees.length || 0
//     // const inactiveCount = employees.filter(e => e?.status === 'DEACTIVE').length
//     // const activeCount = totalEmployees - inactiveCount

//     // Create a map to store unique attendance records per user per day
//     const uniqueMap = new Map()
//         ;(attendance || []).forEach(record => {
//             const dateKey = toLocalDateKey(record.DateString)
//             const userId = record.User_Id
//             if (!dateKey || !userId) return
//             const key = `${userId}_${dateKey}`
//             if (!uniqueMap.has(key)) {
//                 uniqueMap.set(key, { ...record, _dateKey: dateKey })
//             } else {
//                 const existing = uniqueMap.get(key)
//                 if (record.status === 'P' && existing.status !== 'P') {
//                     uniqueMap.set(key, { ...record, _dateKey: dateKey })
//                 }
//             }
//         })

//         // Calculate present, late, and onTime by date
//         const totalUsersByDate = new Map()
//         const presentByDate = new Map()
//         const absentByDate = new Map()
//         const lateByDate = new Map()
//         const onTimeByDate = new Map()

//         uniqueMap.forEach(record => {
//             const dk = record._dateKey

//             if (record.total_users != null) {
//                 totalUsersByDate.set(dk, Number(record.total_users))
//             }

//             if (record.status === 'P') {
//                 presentByDate.set(dk, (presentByDate.get(dk) || 0) + 1)

//                 const [h = '0', m = '0'] = (record.Late_In || '00:00:00').split(':')
//                 const lateMinutes = parseInt(h) * 60 + parseInt(m)

//                 if (lateMinutes > 0) {
//                     lateByDate.set(dk, (lateByDate.get(dk) || 0) + 1)
//                 } else {
//                     onTimeByDate.set(dk, (onTimeByDate.get(dk) || 0) + 1)
//                 }
//             }

//             if (record.status === 'A') {
//                 absentByDate.set(dk, (absentByDate.get(dk) || 0) + 1)
//             }
//         })

//         return getCalendarDays(dateRange.from, dateRange.to).map(dk => {
//             const totalEmployees = totalUsersByDate.get(dk) || 0
//             const present = presentByDate.get(dk) || 0
//             const absent = absentByDate.get(dk) || 0
//             const late = lateByDate.get(dk) || 0
//             const onTime = onTimeByDate.get(dk) || 0

//             return {
//                 date: dk,
//                 present,
//                 absent,
//                 active: present + absent,
//              // inactive: inactiveCount
//                 inactive: totalEmployees - (present + absent),
//                 late,
//                 onTime,
//              // total: present + absent + inactive 
//                 total: totalEmployees
//             }
//         })
//    };

//     const handleDateChange = (type, value) => {
//         setDateRange(prev => ({ ...prev, [type]: value }));
//     };

//     const handleRefresh = () => {
//         fetchInitialData();
//     };

//     const COLORS = {
//         online: '#10b981', offline: '#ef4444', active: '#3b82f6',
//         deactive: '#9ca3af', late: '#f59e0b', earlyout: '#8b5cf6',
//         overtime: '#ec4899', present: '#10b981'
//     };

//     const DARK_BLUE_COLORS = ['#2563eb', '#3b82f6', '#60a5fa', '#93c5fd', '#bfdbfe'];

//     const DailyUserTooltip = ({ active, payload, label }) => {
//         console.log("tooltip payload...", payload)
//         if (active && payload && payload.length) {
//             return (
//                 <div style={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', padding: '10px 14px', color: 'white', fontSize: '13px' }}>
//                     <p style={{ marginBottom: 6, fontWeight: 600 }}>
//                         {new Date(label).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
//                     </p>
//                     {payload.map((entry, i) => {
//                         let color = entry.fill;
//                         let displayName = entry.name;
//                         if (entry.name === 'onTime') displayName = 'On Time';
//                         if (entry.name === 'late') displayName = 'Late';
//                         if (entry.name === 'absent') displayName = 'Absent';
//                         if (entry.name === 'inactive') displayName = 'Inactive';
//                         return (
//                             <p key={i} style={{ color: color, margin: '2px 0' }}>
//                                 {displayName}: <strong>{entry.value}</strong>
//                             </p>
//                         );
//                     })}
//                     <p style={{ marginTop: 6, color: '#93c5fd', borderTop: '1px solid #3b82f6', paddingTop: 4 }}>
//                         Total: <strong>{payload.reduce((sum, entry) => sum + entry.value, 0)}</strong>
//                     </p>
//                 </div>
//             );
//         }
//         return null;
//     };

//     // ─── Wallet Balance Chart Tooltip ─────────────────────────────────────────
//     // const WalletTooltip = ({ active, payload, label }) => {
//     //     if (active && payload && payload.length) {
//     //         return (
//     //             <div style={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', padding: '10px 14px', color: 'white', fontSize: '13px' }}>
//     //                 <p style={{ marginBottom: 4, fontWeight: 600, color: '#93c5fd' }}>{label}</p>
//     //                 <p style={{ color: '#34d399', margin: 0 }}>
//     //                     Balance: <strong>₹{payload[0]?.value?.toLocaleString('en-IN')}</strong>
//     //                 </p>
//     //             </div>
//     //         );
//     //     }
//     //     return null;
//     // };
//     // ─────────────────────────────────────────────────────────────────────────

//     if (loading && initialLoad) {
//         return (
//             <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
//                 <div className="text-center">
//                     <RefreshCw className="w-12 h-12 mx-auto mb-4 text-blue-400 animate-spin" />
//                     <p className="text-blue-200">Loading dashboard data...</p>
//                 </div>
//             </div>
//         );
//     }

//     // // ─── Wallet chart display data ────────────────────────────────────────────
//     // const walletChartData = walletHistory.map(h => ({
//     //     date: new Date(h.date + 'T12:00:00').toLocaleDateString('en-IN', {
//     //         timeZone: orgTimezone,
//     //         day: '2-digit',
//     //         month: 'short'
//     //     }),
//     //     balance: h.balance
//     // }));

//     // const currentBalance = userDetails?.wallet?.balance ?? 0;
//     // const prevDayBalance = walletHistory.length >= 2
//     //     ? walletHistory[walletHistory.length - 2]?.balance
//     //     : null;
//     // const balanceChange = prevDayBalance != null ? currentBalance - prevDayBalance : 0;
//     // const balanceChangePct = prevDayBalance ? ((balanceChange / prevDayBalance) * 100).toFixed(1) : '0.0';
//     // const allBalances = walletHistory.map(h => h.balance);
//     // const maxBalance = allBalances.length ? Math.max(...allBalances) : 0;
//     // const minBalance = allBalances.length ? Math.min(...allBalances) : 0;
//     // const avgBalance = allBalances.length
//     //     ? Math.round(allBalances.reduce((a, b) => a + b, 0) / allBalances.length)
//     //     : 0;
//     // ─────────────────────────────────────────────────────────────────────────

//     return (
//         <div className="min-h-screen pb-8 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
//             {/* Header */}
//             <div className="sticky top-0 z-10 border-b bg-blue-800/20 border-blue-700/60 backdrop-blur-sm">
//                 <div className="px-4 py-2 mx-auto max-w-7xl sm:px-6 lg:px-8">
//                     <div className="flex flex-col md:flex-row md:items-center md:justify-between">
//                         <div className="flex items-center space-x-4">
//                             <div>
//                                 <h1 className="text-3xl font-bold text-white">Overview Dashboard</h1>
//                                 <p className="mt-1 text-blue-200/70">Real-time analysis</p>
//                             </div>
//                             <button
//                                 onClick={handleRefresh}
//                                 className="p-2 text-white transition-colors rounded-lg bg-blue-600/50 hover:bg-blue-600"
//                                 title="Refresh Data"
//                             >
//                                 <RefreshCw className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
//                             </button>
//                         </div>
//                         <div className="flex items-center mt-4 space-x-4 md:mt-0">
//                             <div className="flex items-center space-x-2">
//                                 <input
//                                     type="date"
//                                     value={dateRange.from}
//                                     onChange={(e) => handleDateChange('from', e.target.value)}
//                                     className="px-3 py-2 text-sm text-white border rounded-lg date-input bg-blue-800/20 border-blue-700/60 focus:outline-none focus:border-blue-600"
//                                     max={dateRange.to}
//                                 />
//                                 <span className="text-blue-300">to</span>
//                                 <input
//                                     type="date"
//                                     value={dateRange.to}
//                                     onChange={(e) => handleDateChange('to', e.target.value)}
//                                     className="px-3 py-2 text-sm text-white border rounded-lg date-input bg-blue-800/20 border-blue-700/60 focus:outline-none focus:border-blue-600"
//                                     min={dateRange.from}
//                                     max={new Intl.DateTimeFormat('en-CA', {
//                                         timeZone: 'Pacific/Kiritimati',
//                                         year: 'numeric',
//                                         month: '2-digit',
//                                         day: '2-digit',
//                                     }).format(new Date())}
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="px-3 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8 sm:py-6 lg:py-8">
//                 {/* Stats Cards */}
//                 <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-2 lg:grid-cols-4 sm:gap-6 lg:mb-8">
//                     <StatCard icon={Monitor} title="Total Devices" value={stats.devices.total} bgColor="from-blue-600 to-blue-800" iconBg="bg-blue-400/50">
//                         <div className="flex items-center justify-between mt-3 space-x-2 sm:space-x-4">
//                             <div className="flex items-center space-x-1 sm:-ml-2">
//                                 <div className="w-2 h-2 bg-green-400 rounded-full"></div>
//                                 <span className="text-xs text-blue-200 sm:text-sm">{stats.devices.online} Online</span>
//                             </div>
//                             <div className="flex items-center space-x-1">
//                                 <div className="w-2 h-2 bg-red-400 rounded-full"></div>
//                                 <span className="text-xs text-blue-200 sm:text-sm">{stats.devices.offline} Offline</span>
//                             </div>
//                         </div>
//                     </StatCard>

//                     <StatCard icon={Users} title="Total Employees" value={stats.employees.total} bgColor="from-blue-600 to-blue-800" iconBg="bg-purple-500/20">
//                         <div className="flex items-center justify-between mt-3 space-x-2 sm:space-x-1">
//                             <div className="flex items-center space-x-1 sm:-ml-2">
//                                 <UserCheck className="w-3 h-3 text-green-400 sm:w-4 sm:h-4" />
//                                 <span className="text-xs text-blue-200 sm:text-sm">{stats.employees.active} Active</span>
//                             </div>
//                             <div className="flex items-center space-x-1">
//                                 <UserX className="w-3 h-3 text-gray-400 sm:w-4 sm:h-4" />
//                                 <span className="text-xs text-blue-200 sm:text-sm">{stats.employees.deactive} Inactive</span>
//                             </div>
//                         </div>
//                     </StatCard>

//                     {userDetails?.role !== ACCOUNT_TYPE.MANAGER && (
//                         <StatCard icon={UserCheck} title="Total Managers" value={stats.managers.total} bgColor="from-blue-600 to-blue-800" iconBg="bg-blue-800">
//                             <div className="flex items-center justify-between mt-3 space-x-2 sm:space-x-4">
//                                 <div className="flex items-center space-x-1 sm:space-x-2">
//                                     <UserCheck className="w-3 h-3 text-green-400 sm:w-4 sm:h-4" />
//                                     <span className="text-xs text-blue-200 sm:text-sm">{stats.managers.active} Active</span>
//                                 </div>
//                                 <div className="flex items-center space-x-1 sm:space-x-2">
//                                     <UserX className="w-3 h-3 text-gray-400 sm:w-4 sm:h-4" />
//                                     <span className="text-xs text-blue-200 sm:text-sm">{stats.managers.deactive} Inactive</span>
//                                 </div>
//                             </div>
//                         </StatCard>
//                     )}

//                     <StatCard icon={Calendar} title="Attendance" value={stats.attendance.present} bgColor="from-blue-600 to-blue-800" iconBg="bg-green-500/20">
//                         <div className="mt-2 text-xs text-blue-200 sm:mt-3 sm:text-sm">
//                             Out of {stats.employees.total} employees
//                         </div>
//                     </StatCard>

//                     {userDetails?.role === ACCOUNT_TYPE.MANAGER && (
//                         <StatCard icon={Timer} title="Overtime" value={stats.attendance.overtime} bgColor="from-blue-600 to-blue-800" iconBg="bg-pink-500/20">
//                             <div className="mt-2 text-xs text-blue-200 sm:mt-3 sm:text-sm">Employees working extra</div>
//                         </StatCard>
//                     )}
//                 </div>

//                 {/* {userDetails?.role !== ACCOUNT_TYPE.MANAGER && (
//                     <div className="grid grid-cols-1 gap-4 mb-6 sm:gap-6 lg:mb-8">
//                         <StatCard icon={Timer} title="Overtime" value={stats.attendance.overtime} bgColor="from-blue-600 to-blue-800" iconBg="bg-pink-500/20">
//                             <div className="mt-2 text-xs text-blue-200 sm:mt-3 sm:text-sm">Employees working extra</div>
//                         </StatCard>
//                     </div>
//                 )} */}

//                 {/* Charts Row 1 */}
//                 <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-2 sm:gap-6 lg:mb-8">
//                     <div className="p-4 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60">
//                         <div className="flex items-center justify-between mb-4 sm:mb-6">
//                             <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Device Status</h2>
//                             <Activity className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                         </div>
//                         {stats.devices.total > 0 ? (
//                             <>
//                                 <div className="h-48 sm:h-56 md:h-64">
//                                     <ResponsiveContainer width="100%" height="100%">
//                                         <PieChart>
//                                             <Pie
//                                                 data={[
//                                                     { name: 'Online', value: stats.devices.online },
//                                                     { name: 'Offline', value: stats.devices.offline }
//                                                 ]}
//                                                 cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value"
//                                             >
//                                                 <Cell fill={COLORS.online} />
//                                                 <Cell fill={COLORS.offline} />
//                                             </Pie>
//                                             <Tooltip contentStyle={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', color: 'white', fontSize: '12px' }} />
//                                             <Legend wrapperStyle={{ fontSize: '12px' }} formatter={(value) => <span className="text-xs text-blue-200 sm:text-sm">{value}</span>} />
//                                         </PieChart>
//                                     </ResponsiveContainer>
//                                 </div>
//                                 <div className="grid grid-cols-2 gap-3 mt-4 sm:gap-4">
//                                     <div className="p-2 text-center sm:p-3 bg-blue-900/30 rounded-xl">
//                                         <div className="text-xl font-bold text-green-400 sm:text-2xl">{stats.devices.online}</div>
//                                         <div className="text-xs text-blue-300 sm:text-sm">Online</div>
//                                     </div>
//                                     <div className="p-2 text-center sm:p-3 bg-blue-900/30 rounded-xl">
//                                         <div className="text-xl font-bold text-red-400 sm:text-2xl">{stats.devices.offline}</div>
//                                         <div className="text-xs text-blue-300 sm:text-sm">Offline</div>
//                                     </div>
//                                 </div>
//                             </>
//                         ) : (
//                             <div className="flex items-center justify-center h-48 sm:h-64">
//                                 <p className="text-sm text-blue-300 sm:text-base">No device data available</p>
//                             </div>
//                         )}
//                     </div>

//                     <div className="p-4 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60">
//                         <div className="flex items-center justify-between mb-4 sm:mb-6">
//                             <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">
//                                 {userDetails?.role !== ACCOUNT_TYPE.MANAGER ? 'Employee & Manager Status' : 'Employee Status'}
//                             </h2>
//                             <Users className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                         </div>
//                         {stats.employees.total > 0 ? (
//                             <div className="h-64 sm:h-80 lg:h-96">
//                                 <ResponsiveContainer width="100%" height="100%">
//                                     <BarChart data={
//                                         userDetails?.role !== ACCOUNT_TYPE.MANAGER
//                                             ? [
//                                                 { name: 'Employees Active', value: stats.employees.active },
//                                                 { name: 'Employees Inactive', value: stats.employees.deactive },
//                                                 { name: 'Managers Active', value: stats.managers.active },
//                                                 { name: 'Managers Inactive', value: stats.managers.deactive }
//                                             ]
//                                             : [
//                                                 { name: 'Active', value: stats.employees.active },
//                                                 { name: 'Inactive', value: stats.employees.deactive }
//                                             ]
//                                     }>
//                                         <CartesianGrid strokeDasharray="3 3" stroke="#2563eb20" />
//                                         <XAxis 
//                                             dataKey="name" 
//                                             stroke="#60a5fa" 
//                                             angle={-35} 
//                                             textAnchor="end" 
//                                             height={70} 
//                                             tick={{ fontSize: 10, fill: '#93c5fd' }}
//                                             interval={0}
//                                         />
//                                         <YAxis stroke="#60a5fa" tick={{ fontSize: 11, fill: '#93c5fd' }} />
//                                         <Tooltip contentStyle={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', color: 'white', fontSize: '12px' }} />
//                                         <Bar dataKey="value" fill="#3b82f6" />
//                                     </BarChart>
//                                 </ResponsiveContainer>
//                             </div>
//                         ) : (
//                             <div className="flex items-center justify-center h-48 sm:h-64">
//                                 <p className="text-sm text-blue-300 sm:text-base">No employee data available</p>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Charts Row 2 */}
//                 <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-2 sm:gap-6 lg:mb-8">
//                     <div className="p-4 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60">
//                         <div className="flex items-center justify-between mb-4 sm:mb-6">
//                             <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Attendance Analytics</h2>
//                             <Clock className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                         </div>
//                         {stats.attendance.total > 0 ? (
//                             <>
//                                 <div className="grid grid-cols-2 gap-3 mb-4 sm:gap-4 sm:mb-6">
//                                     <div className="p-3 sm:p-4 bg-blue-900/30 rounded-xl">
//                                         <div className="flex items-center space-x-2 sm:space-x-3">
//                                             <AlertCircle className="w-5 h-5 text-yellow-400 sm:w-6 sm:h-6 md:w-8 md:h-8" />
//                                             <div>
//                                                 <div className="text-lg font-bold text-white sm:text-xl md:text-2xl">{stats.attendance.late}</div>
//                                                 <div className="text-xs text-blue-300 sm:text-sm">Late Arrivals</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="p-3 sm:p-4 bg-blue-900/30 rounded-xl">
//                                         <div className="flex items-center space-x-2 sm:space-x-3">
//                                             <Clock className="w-5 h-5 text-purple-400 sm:w-6 sm:h-6 md:w-8 md:h-8" />
//                                             <div>
//                                                 <div className="text-lg font-bold text-white sm:text-xl md:text-2xl">{stats.attendance.earlyOut}</div>
//                                                 <div className="text-xs text-blue-300 sm:text-sm">Early Out</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="h-40 sm:h-48 md:h-56">
//                                     <ResponsiveContainer width="100%" height="100%">
//                                         <BarChart data={[
//                                             { name: 'Late', value: stats.attendance.late },
//                                             { name: 'Early Out', value: stats.attendance.earlyOut },
//                                             { name: 'Overtime', value: stats.attendance.overtime }
//                                         ]}>
//                                             <CartesianGrid strokeDasharray="3 3" stroke="#2563eb20" />
//                                             <XAxis dataKey="name" stroke="#60a5fa" tick={{ fontSize: 11, fill: '#93c5fd' }} />
//                                             <YAxis stroke="#60a5fa" tick={{ fontSize: 11, fill: '#93c5fd' }} />
//                                             <Tooltip contentStyle={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', color: 'white', fontSize: '12px' }} />
//                                             <Bar dataKey="value" fill="#3b82f6" />
//                                         </BarChart>
//                                     </ResponsiveContainer>
//                                 </div>
//                             </>
//                         ) : (
//                             <div className="flex items-center justify-center h-48 sm:h-64">
//                                 <p className="text-sm text-center text-blue-300 sm:text-base">No attendance data available for selected date range</p>
//                             </div>
//                         )}
//                     </div>

//                     <div className="p-4 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60">
//                         <div className="flex items-center justify-between mb-4 sm:mb-6">
//                             <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Department Distribution</h2>
//                             <ChartPie className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                         </div>
//                         {departmentStats.length > 0 ? (
//                             <div className="h-48 sm:h-56 md:h-72">
//                                 <ResponsiveContainer width="100%" height="100%">
//                                     <PieChart>
//                                         <Pie data={departmentStats} cx="50%" cy="50%" outerRadius={70} dataKey="total" nameKey="name" label={({ name, percent }) => window.innerWidth > 640 ? `${name}: ${(percent * 100).toFixed(0)}%` : ''}>
//                                             {departmentStats.map((entry, index) => (
//                                                 <Cell key={`cell-${index}`} fill={DARK_BLUE_COLORS[index % DARK_BLUE_COLORS.length]} />
//                                             ))}
//                                         </Pie>
//                                         <Tooltip contentStyle={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', color: 'white', fontSize: '12px' }} />
//                                         <Legend wrapperStyle={{ fontSize: '11px' }} formatter={(value) => <span className="text-xs text-blue-200 sm:text-sm">{value}</span>} />
//                                     </PieChart>
//                                 </ResponsiveContainer>
//                             </div>
//                         ) : (
//                             <div className="flex items-center justify-center h-48 sm:h-64">
//                                 <p className="text-sm text-blue-300 sm:text-base">No department data available</p>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Attendance Trend */}
//                 <div className="p-4 mb-6 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60 sm:mb-8">
//                     <div className="flex items-center justify-between mb-4 sm:mb-6">
//                         <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Attendance Trend</h2>
//                         <TrendingUp className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                     </div>
//                     {attendanceTrend.length > 0 ? (
//                         <div className="h-64 sm:h-72 md:h-80">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <LineChart data={attendanceTrend}>
//                                     <CartesianGrid strokeDasharray="3 3" stroke="#2563eb20" />
//                                     <XAxis
//                                         dataKey="date"
//                                         stroke="#60a5fa"
//                                         tickFormatter={(value) =>
//                                             new Date(value + 'T12:00:00').toLocaleDateString("en-IN", {
//                                                 timeZone: orgTimezone, day: "2-digit", month: "short"
//                                             })
//                                         }
//                                         tick={{ fontSize: 10, fill: '#93c5fd' }}
//                                         interval="preserveStartEnd"
//                                     />
//                                     <YAxis stroke="#60a5fa" tick={{ fontSize: 11, fill: '#93c5fd' }} />
//                                     <Tooltip contentStyle={{ backgroundColor: '#1e3a8a', border: '1px solid #3b82f6', borderRadius: '0.5rem', color: 'white', fontSize: '12px' }} />
//                                     <Legend wrapperStyle={{ fontSize: '11px' }} formatter={(value) => <span className="text-xs text-blue-200 sm:text-sm">{value}</span>} />
//                                     <Line type="monotone" dataKey="present" stroke="#10b981" strokeWidth={2} dot={{ r: 3 }} />
//                                     <Line type="monotone" dataKey="late" stroke="#f59e0b" strokeWidth={2} dot={{ r: 3 }} />
//                                     <Line type="monotone" dataKey="earlyOut" stroke="#8b5cf6" strokeWidth={2} dot={{ r: 3 }} />
//                                     <Line type="monotone" dataKey="overtime" stroke="#ec4899" strokeWidth={2} dot={{ r: 3 }} />
//                                 </LineChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : (
//                         <div className="flex items-center justify-center h-48 sm:h-64">
//                             <p className="text-sm text-blue-300 sm:text-base">No trend data available for selected date range</p>
//                         </div>
//                     )}
//                 </div>

//                 {/* Daily User Analysis */}
//                 <div className="p-4 mb-6 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60 sm:mb-8">
//                     <div className="flex flex-col mb-4 space-y-2 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:mb-6">
//                         <div>
//                             <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Daily User Analysis</h2>
//                             <p className="text-xs text-blue-300/70 sm:text-sm">Per-day breakdown of OnTime, Late, Absent, Inactive &amp; Total users</p>
//                         </div>
//                         <BarChart2 className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                     </div>

//                     <div className="flex flex-wrap gap-2 mt-2 mb-4 sm:gap-3 sm:mb-6">
//                         {[
//                             { color: '#22c55e', label: 'On Time' },
//                             { color: '#eab308', label: 'Late' },
//                             { color: '#ef4444', label: 'Absent' },
//                             { color: '#9ca3af', label: 'Inactive' },
//                         ].map(item => (
//                             <div key={item.label} className="flex items-center px-2 py-1 space-x-1 border rounded-full sm:px-3 sm:py-1 sm:space-x-2 bg-blue-900/30 border-blue-800/30">
//                                 <div className="w-2 h-2 rounded-full sm:w-3 sm:h-3" style={{ backgroundColor: item.color }}></div>
//                                 <span className="text-xs text-blue-200 sm:text-sm">{item.label}</span>
//                             </div>
//                         ))}
//                     </div>

//                     {dailyUserStats.length > 0 ? (
//                         <div className="h-64 -mb-8 sm:h-80 md:h-96 sm:-mb-10">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart data={dailyUserStats} margin={{ top: 10, right: 10, left: 0, bottom: 50 }} barCategoryGap="15%" barGap={2}>
//                                     <CartesianGrid strokeDasharray="3 3" stroke="#2563eb20" />
//                                     <XAxis
//                                         dataKey="date"
//                                         stroke="#60a5fa"
//                                         tick={{ fill: '#93c5fd', fontSize: 9 }}
//                                         tickFormatter={(value) =>
//                                             new Date(value + 'T12:00:00').toLocaleDateString("en-IN", {
//                                                 timeZone: orgTimezone, day: "2-digit", month: "short"
//                                             })
//                                         }
//                                         angle={-45}
//                                         textAnchor="end"
//                                         height={60}
//                                         interval={dailyUserStats.length > 10 ? Math.floor(dailyUserStats.length / 10) : 0}
//                                     />
//                                     <YAxis
//                                         stroke="#60a5fa"
//                                         tick={{ fill: '#93c5fd', fontSize: 10 }}
//                                         allowDecimals={false}
//                                         label={{ value: 'No. of Users', angle: -90, position: 'insideLeft', offset: 10, style: { fill: '#93c5fd', fontSize: 11 } }}
//                                     />
//                                     <Tooltip content={<DailyUserTooltip />} />
//                                     <Legend wrapperStyle={{ fontSize: '11px' }} formatter={(value) => <span className="text-blue-200">{value}</span>} />
//                                     <Bar dataKey="onTime" name="On Time" stackId="stack" fill="#22c55e" radius={[0, 0, 0, 0]} />
//                                     <Bar dataKey="late" name="Late" stackId="stack" fill="#eab308" radius={[0, 0, 0, 0]} />
//                                     <Bar dataKey="absent" name="Absent" stackId="stack" fill="#ef4444" radius={[0, 0, 0, 0]} />
//                                     <Bar dataKey="inactive" name="Inactive" stackId="stack" fill="#9ca3af" radius={[4, 4, 0, 0]} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : (
//                         <div className="flex flex-col items-center justify-center h-48 space-y-2 sm:h-64">
//                             <BarChart2 className="w-8 h-8 text-blue-700 sm:w-10 sm:h-10" />
//                             <p className="text-sm text-center text-blue-300 sm:text-base">No data available for selected date range</p>
//                         </div>
//                     )}

//                     {dailyUserStats.length > 0 && (
//                         <div className="grid grid-cols-2 gap-2 mt-4 sm:grid-cols-5 sm:gap-3">
//                             <div className="p-2 text-center border sm:p-3 bg-blue-600/20 rounded-xl border-blue-700/90">
//                                 <div className="text-base font-bold text-blue-200 sm:text-lg">{dailyUserStats[0]?.total ?? 0}</div>
//                                 <div className="mt-1 text-[10px] text-blue-300 sm:text-xs">Total Employees</div>
//                             </div>
//                             <div className="p-2 text-center border sm:p-3 bg-green-900/20 rounded-xl border-green-700/20">
//                                 <div className="text-base font-bold text-green-400 sm:text-lg">
//                                     {dailyUserStats.length > 0 ? Math.round(dailyUserStats.reduce((s, d) => s + d.onTime, 0) / dailyUserStats.length) : 0}
//                                 </div>
//                                 <div className="mt-1 text-[10px] text-blue-400 sm:text-xs">Avg On Time / Day</div>
//                             </div>
//                             <div className="p-2 text-center border sm:p-3 bg-yellow-700/30 rounded-xl border-yellow-700/50">
//                                 <div className="text-base font-bold text-yellow-400 sm:text-lg">
//                                     {dailyUserStats.length > 0 ? Math.round(dailyUserStats.reduce((s, d) => s + d.late, 0) / dailyUserStats.length) : 0}
//                                 </div>
//                                 <div className="mt-1 text-[10px] text-blue-400 sm:text-xs">Avg Late / Day</div>
//                             </div>
//                             <div className="p-2 text-center border sm:p-3 bg-red-900/20 rounded-xl border-red-700/20">
//                                 <div className="text-base font-bold text-red-400 sm:text-lg">
//                                     {dailyUserStats.length > 0 ? Math.round(dailyUserStats.reduce((s, d) => s + d.absent, 0) / dailyUserStats.length) : 0}
//                                 </div>
//                                 <div className="mt-1 text-[10px] text-blue-400 sm:text-xs">Avg Absent / Day</div>
//                             </div>
//                             <div className="p-2 text-center border sm:p-3 bg-gray-700/20 rounded-xl border-gray-600/20">
//                                 <div className="text-base font-bold text-gray-400 sm:text-lg">{dailyUserStats[0]?.inactive ?? 0}</div>
//                                 <div className="mt-1 text-[10px] text-blue-400 sm:text-xs">Inactive Employees</div>
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* Wallet Balance History - Daily Balance Tracking */}
//                 {userDetails.role === "Organization" && (
//                     <div className="p-4 mb-6 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60 sm:mb-8">
//                         <div className="flex flex-col mb-4 space-y-2 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:mb-6">
//                             <div>
//                                 <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Wallet Balance History</h2>
//                                 <p className="text-xs text-blue-300 sm:text-sm">
//                                     Daily balance tracking 
//                                 </p>
//                             </div>
//                             <ChartLine className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                             {/* <button
//                                 onClick={() => fetchWalletBalance(dispatch, setLoading)}
//                                 className="p-2 text-white transition-colors rounded-lg bg-blue-600/50 hover:bg-blue-600"
//                                 title="Refresh Wallet Data"
//                             >
//                                 <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
//                             </button> */}
//                         </div>

//                         {/* Wallet Balance Chart */}
//                         {walletHistoryData.length > 0 ? (
//                             <>
//                                 <div className="h-64 sm:h-72 md:h-80">
//                                     <ResponsiveContainer width="100%" height="100%">
//                                         <LineChart data={walletHistoryData} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
//                                             <defs>
//                                                 <linearGradient id="walletGradient" x1="0" y1="0" x2="0" y2="1">
//                                                     <stop offset="5%" stopColor="#34d399" stopOpacity={0.3} />
//                                                     <stop offset="95%" stopColor="#34d399" stopOpacity={0} />
//                                                 </linearGradient>
//                                             </defs>
//                                             <CartesianGrid strokeDasharray="3 3" stroke="#2563eb20" />
//                                             <XAxis 
//                                                 dataKey="date" 
//                                                 stroke="#60a5fa"
//                                                 tick={{ fill: '#93c5fd', fontSize: 10 }}
//                                                 tickFormatter={(value) => {
//                                                     const d = new Date(value);
//                                                     return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
//                                                 }}
//                                                 angle={-45}
//                                                 textAnchor="end"
//                                                 height={60}
//                                                 interval={walletHistoryData.length > 14 ? Math.floor(walletHistoryData.length / 14) : 0}
//                                             />
//                                             <YAxis 
//                                                 stroke="#60a5fa"
//                                                 tick={{ fill: '#93c5fd', fontSize: 10 }}
//                                                 tickFormatter={(v) => '₹' + v.toLocaleString('en-IN')}
//                                                 label={{ 
//                                                     value: 'Balance (₹)', 
//                                                     angle: -90, 
//                                                     position: 'insideLeft',
//                                                     style: { fill: '#93c5fd', fontSize: 11 }
//                                                 }}
//                                             />
//                                             <Tooltip content={<WalletBalanceTooltip />} />
//                                             <Legend 
//                                                 wrapperStyle={{ fontSize: '11px', paddingTop: '10px' }}
//                                                 formatter={(value) => <span className="text-xs text-blue-200 sm:text-sm">{value}</span>}
//                                             />
//                                             <Line 
//                                                 type="monotone" 
//                                                 dataKey="totalAmount" 
//                                                 stroke="#34d399" 
//                                                 strokeWidth={2}
//                                                 name="Balance"
//                                                 dot={{ r: 3, fill: "#34d399", strokeWidth: 1.5 }}
//                                                 activeDot={{ r: 5, fill: "#34d399", stroke: "#0f172a", strokeWidth: 1.5 }}
//                                                 fillOpacity={0.3}
//                                                 fill="url(#walletGradient)"
//                                             />
//                                         </LineChart>
//                                     </ResponsiveContainer>
//                                 </div>

//                                 {/* Recent Transactions Table */}
//                                 {walletStats.recentTransactions.length > 0 && (
//                                 <div className="p-2 mt-4 overflow-x-auto sm:p-4 bg-richblue-800/20 sm:mt-6">
//                                     <h3 className="mb-3 text-sm font-semibold text-white sm:text-base md:text-lg">Balance History</h3>
//                                     <div className="overflow-x-auto">
//                                     <div className="max-h-[400px] overflow-y-auto relative">
//                                         <table className="min-w-[500px] w-full border-collapse sm:min-w-full">
//                                         <thead className="sticky top-0 z-10">
//                                             <tr className="border-b border-blue-800/30 bg-blue-900/10">
//                                             <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap sm:px-3 sm:text-sm">Date</th>
//                                             <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap sm:px-3 sm:text-sm">Total Users</th>
//                                             <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap sm:px-3 sm:text-sm">Subtracted Amount</th>
//                                             <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 whitespace-nowrap sm:px-3 sm:text-sm">Current Balance</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {walletStats.recentTransactions.map((transaction, idx) => (
//                                             <tr 
//                                                 key={idx} 
//                                                 className={`border-b border-blue-800/20 hover:bg-blue-900/20 transition-colors ${
//                                                 idx % 2 === 0 ? 'bg-blue-900/5' : ''
//                                                 }`}
//                                             >
//                                                 <td className="px-2 py-2 text-xs text-gray-200 whitespace-nowrap sm:px-3 sm:py-3">
//                                                 {new Date(transaction.DateString).toLocaleDateString("en-IN", {
//                                                     day: "2-digit",
//                                                     month: "short",
//                                                     year: "numeric"
//                                                 })}
//                                                 </td>
//                                                 <td className="px-2 py-2 text-xs text-gray-400 whitespace-nowrap sm:px-3 sm:py-3">
//                                                 {transaction.subtractamount || transaction.orgId?.totalUsers || 0}
//                                                 </td>
//                                                 <td className="px-2 py-2 text-xs text-red-400 whitespace-nowrap sm:px-3 sm:py-3">
//                                                 -₹{(transaction.subtractamount || 0).toLocaleString('en-IN')}
//                                                 </td>
//                                                 <td className="px-2 py-2 text-xs font-medium text-green-400 whitespace-nowrap sm:px-3 sm:py-3">
//                                                 ₹{(transaction.totalamount || 0).toLocaleString('en-IN')}
//                                                 </td>
//                                             </tr>
//                                             ))}
//                                         </tbody>
//                                         </table>
                                        
//                                         {/* Scroll Indicator */}
//                                         {walletStats.recentTransactions.length > 5 && (
//                                         <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#0B0F1C] to-transparent pointer-events-none"></div>
//                                         )}
//                                     </div>
                                    
//                                     {/* Scroll Hint for Mobile */}
//                                     {walletStats.recentTransactions.length > 3 && (
//                                         <div className="mt-2 text-center sm:mt-3">
//                                         <p className="text-[10px] text-blue-400/60 flex items-center justify-center gap-1 sm:text-xs">
//                                             <svg className="w-2 h-2 animate-bounce sm:w-3 sm:h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//                                             </svg>
//                                             Scroll for more
//                                             <svg className="w-2 h-2 animate-bounce sm:w-3 sm:h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//                                             </svg>
//                                         </p>
//                                         </div>
//                                     )}
//                                     </div>
//                                 </div>
//                                 )}
//                             </>
//                         ) : (
//                             <div className="flex flex-col items-center justify-center h-48 space-y-2 sm:h-64">
//                                 <Wallet className="w-8 h-8 text-blue-700 sm:w-10 sm:h-10" />
//                                 <p className="text-sm text-center text-blue-300 sm:text-base">No wallet data available for selected date range</p>
//                                 <button
//                                     onClick={() => fetchWalletBalance(dispatch, setLoading)}
//                                     className="px-3 py-1.5 mt-2 text-xs text-white transition-colors rounded-lg sm:px-4 sm:py-2 sm:text-sm bg-blue-600/50 hover:bg-blue-600"
//                                 >
//                                     Load Wallet Data
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 )}    

//                 {/* Device List Table */}
//                 <div className="p-4 border sm:p-6 bg-blue-800/20 backdrop-blur-sm rounded-2xl border-blue-700/60">
//                     <div className="flex items-center justify-between mb-4 sm:mb-6">
//                         <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">Device Activity</h2>
//                         <HardDrive className="w-4 h-4 text-blue-400 sm:w-5 sm:h-5" />
//                     </div>
//                     {deviceActivity.length > 0 ? (
//                         <div className="overflow-x-auto">
//                             <table className="min-w-[600px] w-full sm:min-w-full">
//                                 <thead>
//                                     <tr className="border-b border-blue-800/30 bg-blue-900/10">
//                                         <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 sm:px-4 sm:py-3 sm:text-sm">Device Name</th>
//                                         <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 sm:px-4 sm:py-3 sm:text-sm">Location</th>
//                                         <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 sm:px-4 sm:py-3 sm:text-sm">Users Count</th>
//                                         <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 sm:px-4 sm:py-3 sm:text-sm">Status</th>
//                                         <th className="px-2 py-2 text-xs font-bold tracking-wider text-left text-blue-300 sm:px-4 sm:py-3 sm:text-sm">Last Seen</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {deviceActivity.map((device, index) => (
//                                         <tr key={index} className="transition-colors border-b border-blue-800/20 hover:bg-blue-900/20">
//                                             <td className="px-2 py-2 sm:px-4 sm:py-3">
//                                                 <div className="flex items-center space-x-1 sm:space-x-3">
//                                                     <Monitor className="w-3 h-3 text-blue-400 sm:w-4 sm:h-4" />
//                                                     <span className="text-xs text-white sm:text-sm">{device.name}</span>
//                                                 </div>
//                                             </td>
//                                             <td className="px-2 py-2 text-xs text-gray-400 sm:px-4 sm:py-3 sm:text-sm">{device.location}</td>
//                                             <td className="px-2 py-2 sm:px-4 sm:py-3">
//                                                 <span className="px-1.5 py-0.5 text-xs text-gray-400 rounded-full sm:px-2 sm:py-1 sm:text-sm bg-blue-900/30">
//                                                     {device.users} 
//                                                 </span>
//                                             </td>
//                                             <td className="px-2 py-2 sm:px-4 sm:py-3">
//                                                 <span className={`flex items-center space-x-1 text-xs sm:text-sm ${device.status === 'ONLINE' || device.status === 'HEARTBEAT' ? 'text-green-400' : 'text-red-400'}`}>
//                                                     {device.status === 'ONLINE' || device.status === 'HEARTBEAT' ? (
//                                                         <Wifi className="w-3 h-3 sm:w-4 sm:h-4" />
//                                                     ) : (
//                                                         <WifiOff className="w-3 h-3 sm:w-4 sm:h-4" />
//                                                     )}
//                                                     <span>{device.status}</span>
//                                                 </span>
//                                             </td>
//                                             <td className="px-2 py-2 text-xs text-gray-400 sm:px-4 sm:py-3 sm:text-sm">
//                                                 {new Date(device.last_seen).toLocaleString()}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     ) : (
//                         <div className="py-6 text-center sm:py-8">
//                             <p className="text-sm text-blue-300 sm:text-base">No device data available</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// const StatCard = ({ icon: Icon, title, value, bgColor, iconBg, children }) => {
//     return (
//         <div className={`bg-gradient-to-br ${bgColor} rounded-xl p-4 shadow-lg sm:p-6`}>
//             <div className="flex items-center justify-between">
//                 <div>
//                     <p className="text-xs text-blue-100 sm:text-sm">{title}</p>
//                     <p className="mt-1 text-xl font-bold text-white sm:text-2xl lg:text-3xl">{value}</p>
//                 </div>
//                 <div className={`p-2 ${iconBg} rounded-xl sm:p-3`}>
//                     <Icon className="w-4 h-4 text-white sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
//                 </div>
//             </div>
//             {children}
//         </div>
//     );
// };

// export default OverviewDashboard;


import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Wifi,
    WifiOff,
    Users,
    UserCheck,
    UserX,
    Clock,
    Timer,
    TrendingUp,
    Calendar,
    Activity,
    Monitor,
    HardDrive,
    RefreshCw,
    Wallet,
    ChartLine,
    ChartPie
} from 'lucide-react';
import {
    LineChart,
    Line,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell
} from 'recharts';

import { Get_Devices, Get_Org_Devices } from '../../../services/oprations/Device';
import { Get_Managers_User, Get_Users } from '../../../services/oprations/Users';
import { Get_Attendance, Get_Attendance_Org } from '../../../services/oprations/Attendance';
import { Get_Managers } from '../../../services/oprations/Manager';
import useSocket from '../../../hooks/useSocket';
import { ACCOUNT_TYPE } from '../../../utils/Account_Type';
import { GetWalletTracking } from '../../../services/oprations/Bussiness_Logic';
import { useTheme } from '../../../Context/themeContext';

const OverviewDashboard = () => {
    const dispatch = useDispatch();
    const socket = useSocket();
    const { theme } = useTheme();
    const isDark = theme !== 'light';

    const [loading, setLoading] = useState(true);
    const [initialLoad, setInitialLoad] = useState(true);
    const token = localStorage.getItem("token");

    const { user } = useSelector((state) => state.profile)
    const userDetails = typeof user == 'string' ? JSON.parse(user) : user
    console.log("profile details...", userDetails)

    const orgTimezone = userDetails?.timeZone?.value || 'Asia/Calcutta'

    const toLocalDateKey = useCallback((raw) => {
        if (!raw) return null
        if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw.trim())) return raw.trim()
        const d = new Date(raw)
        if (isNaN(d.getTime())) return null
        return d.toLocaleDateString('en-CA', { timeZone: orgTimezone })
    },[orgTimezone]);

    //const getTodayKey = () => new Date().toLocaleDateString('en-CA', { timeZone: orgTimezone })
const getTodayKey = useCallback(() => {
  return new Date().toLocaleDateString('en-CA', { timeZone: orgTimezone });
}, [orgTimezone]);
    const getCalendarDays = useCallback((fromStr, toStr) => {
        const days = []
        const todayKey = getTodayKey()
        const [sy, sm, sd] = fromStr.split('-').map(Number)
        const [ey, em, ed] = toStr.split('-').map(Number)
        const start = new Date(sy, sm - 1, sd, 12, 0, 0)
        const end   = new Date(ey, em - 1, ed, 12, 0, 0)
        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            const dk = d.toLocaleDateString('en-CA', { timeZone: orgTimezone })
            if (dk > todayKey) break
            days.push(dk)
        }
        return days
    },[getTodayKey, orgTimezone]);

    const { devices } = useSelector(state => state.device) || { devices: [] };
    const { users } = useSelector(state => state.user) || { users: [] };
    console.log("users", users)
    const { managers } = useSelector(state => state.manager) || { managers: [] };
    const { attendance } = useSelector(state => state.Attendance) || { attendance: [] };

    const attendanceData = React.useMemo(() => {
        if (!attendance) return [];
        return typeof attendance === 'string' ? JSON.parse(attendance) : attendance;
    }, [attendance]);

    const employeesData = React.useMemo(() => {
        if (!users) return [];
        return typeof users === 'string' ? JSON.parse(users) : users;
    }, [users]);
    console.log("users...",users)

    const managersData = React.useMemo(() => {
        if (!managers) return [];
        return typeof managers === 'string' ? JSON.parse(managers) : managers;
    }, [managers]);

    const devicesData = React.useMemo(() => {
        if (!devices) return [];
        return typeof devices === 'string' ? JSON.parse(devices) : devices;
    }, [devices]);

    const getCurrentMonthRange = () => {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
        return {
            from: firstDay.toISOString().split('T')[0],
            to: new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Pacific/Kiritimati',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(today)
        };
    };

    const [dateRange, setDateRange] = useState(getCurrentMonthRange());

    const [stats, setStats] = useState({
        devices: { total: 0, online: 0, offline: 0 },
        employees: { total: 0, active: 0, deactive: 0 },
        managers: { total: 0, active: 0, deactive: 0 },
        attendance: { 
            earlyIn: 0, 
            lateIn: 0, 
            earlyOut: 0, 
            lateOut: 0, 
            present: 0, 
            undertime: 0, 
            overtime: 0, 
            total: 0 
        }
    });

    const [attendanceTrend, setAttendanceTrend] = useState([]);
    const [deviceActivity, setDeviceActivity] = useState([]);
    const [departmentStats, setDepartmentStats] = useState([]);
    const [dailyUserStats, setDailyUserStats] = useState([]);

    // ─── Wallet Balance History ──────────────────────────────────────────────
    // eslint-disable-next-line
    const [walletHistory, setWalletHistory] = useState([]);
    const [walletHistoryData, setWalletHistoryData] = useState([]);
    const [walletStats, setWalletStats] = useState({
        maxBalance: 0,
        minBalance: 0,
        avgBalance: 0,
        totalTransactions: 0,
        recentTransactions: []
    });

    // ─── Theme-aware style tokens ──────────────────────────────────────────────
    const styles = {
        pageBg: isDark
            ? 'from-slate-900 via-blue-900 to-slate-900'
            : 'from-slate-100 via-gray-100 to-slate-100',
        headerBg: isDark
            ? 'bg-blue-800/20 border-blue-700/60'
            : 'bg-white border-slate-200',
        cardBg: isDark
            ? 'bg-blue-800/20 border-blue-700/60'
            : 'bg-white border-slate-200 shadow-sm',
        innerBg: isDark ? 'bg-blue-900/30' : 'bg-slate-50',
        innerBgAlt: isDark ? 'bg-blue-900/10' : 'bg-slate-50',
        textPrimary: isDark ? 'text-white' : 'text-slate-900',
        textSecondary: isDark ? 'text-blue-200/70' : 'text-slate-500',
        textMuted: isDark ? 'text-blue-300' : 'text-slate-500',
        textMutedFaint: isDark ? 'text-blue-300/70' : 'text-slate-400',
        textAccent: isDark ? 'text-blue-200' : 'text-slate-600',
        border: isDark ? 'border-blue-700/60' : 'border-slate-200',
        borderSoft: isDark ? 'border-blue-800/30' : 'border-slate-100',
        rowHover: isDark ? 'hover:bg-blue-900/20' : 'hover:bg-slate-50',
        inputBg: isDark
            ? 'bg-blue-800/20 border-blue-700/60 text-white'
            : 'bg-white border-slate-200 text-slate-900',
        refreshBtn: isDark
            ? 'bg-blue-600/50 hover:bg-blue-600 text-white'
            : 'bg-blue-600 hover:bg-blue-700 text-white',
        statCardBg: isDark
            ? 'bg-gradient-to-br from-blue-600 to-blue-800'
            : 'bg-white border border-slate-200 shadow-sm',
        statValueText: isDark ? 'text-white' : 'text-slate-900',
        statLabelText: isDark ? 'text-blue-100' : 'text-slate-500',
        statSubText: isDark ? 'text-blue-100' : 'text-slate-500',
        statChipText: isDark ? 'text-blue-100' : 'text-slate-600',
        gridStroke: isDark ? '#2563eb20' : '#e2e8f0',
        axisStroke: isDark ? '#60a5fa' : '#94a3b8',
        axisTick: isDark ? '#93c5fd' : '#64748b',
        tooltipBg: isDark ? '#1e3a8a' : '#ffffff',
        tooltipBorder: isDark ? '#3b82f6' : '#e2e8f0',
        tooltipText: isDark ? 'white' : '#1e293b',
    };

    // ─── Department Colors - Different vibrant colors ──────────────────────────
    const DEPARTMENT_COLORS = [
        '#FF6B6B', // Red
        '#4ECDC4', // Teal
        '#45B7D1', // Sky Blue
        '#96CEB4', // Sage Green
        '#FFEAA7', // Light Yellow
        '#DDA0DD', // Plum
        '#FF9F43', // Orange
        '#A29BFE', // Lavender
        '#FD79A8', // Pink
        '#00B894', // Emerald
        '#E17055', // Coral
        '#74B9FF', // Light Blue
        '#FDCB6E', // Gold
        '#6C5CE7', // Purple
        '#00CEC9', // Cyan
        '#E84393', // Hot Pink
        '#0984E3', // Royal Blue
        '#00B894', // Mint
        '#F8A5C2', // Rose
        '#778BEB', // Periwinkle
    ];

    useEffect(() => {
        const currentBalance = userDetails?.wallet?.balance;
        if (currentBalance == null) return;

        const orgId = userDetails?._id || 'default';
        const storageKey = `wallet_history_${orgId}`;
        const todayKey = getTodayKey();

        let history = [];
        try {
            const raw = localStorage.getItem(storageKey);
            history = raw ? JSON.parse(raw) : [];
        } catch {
            history = [];
        }

        const todayIndex = history.findIndex(h => h.date === todayKey);
        if (todayIndex === -1) {
            history = [...history, { date: todayKey, balance: currentBalance }];
        } else {
            history[todayIndex] = { date: todayKey, balance: currentBalance };
        }

        localStorage.setItem(storageKey, JSON.stringify(history));
        setWalletHistory(history);
    }, [userDetails?.wallet?.balance, userDetails?._id, getTodayKey]);



    useEffect(() => {
        if (!socket) return
        socket.on("Device_Status", (data) => {
            userDetails?.role === ACCOUNT_TYPE.MANAGER ? dispatch(Get_Devices(token)) : dispatch(Get_Org_Devices(token))
        })
        return () => {
            socket.off("Device_Status");
        };
    }, [socket, dispatch, token, userDetails?.role])


   /*const fetchInitialData = async () => {
        setLoading(true);
        try {
            const promises = [
                userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Devices(token)) : dispatch(Get_Org_Devices(token)),
                userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Managers_User(token)) : dispatch(Get_Users(token)),
                userDetails?.role == ACCOUNT_TYPE.MANAGER ? dispatch(Get_Attendance('All', dateRange.from, dateRange.to)) : dispatch(Get_Attendance_Org('All', dateRange.from, dateRange.to))
            ];
            if (userDetails?.role !== ACCOUNT_TYPE.MANAGER) {
                promises.push(dispatch(Get_Managers(token)));
            }

            await Promise.all(promises);

            await fetchWalletBalance(dispatch, setLoading);

            setInitialLoad(false);
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            setInitialLoad(false);
        } finally {
            setLoading(false);
        }
    };*/


    const fetchAttendanceData = useCallback(async () => {
        setLoading(true);
        try {
            userDetails?.role === ACCOUNT_TYPE.MANAGER
                ? await dispatch(Get_Attendance('All', dateRange.from, dateRange.to))
                : await dispatch(Get_Attendance_Org('All', dateRange.from, dateRange.to));
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        } finally {
            setLoading(false);
        }
    },[dateRange.from, dateRange.to, dispatch, userDetails?.role]);

        useEffect(() => {
        if (!initialLoad) {
            fetchAttendanceData();
        }
    }, [dateRange, fetchAttendanceData, initialLoad]);
    // eslint-disable-next-line
    const processWalletData = useCallback((walletData, dateRangeFrom, dateRangeTo) => {
        if (!walletData || !Array.isArray(walletData) || walletData.length === 0) {
            console.log("No wallet data to process");
            return [];
        }

        console.log("Processing wallet data:", walletData);

        const filteredData = walletData.filter(item => {
            if (!item.DateString) return false;
            const itemDate = new Date(item.DateString).toISOString().split('T')[0];
            return itemDate >= dateRangeFrom && itemDate <= dateRangeTo;
        });

        console.log("Filtered data by date range:", filteredData);

        const sortedData = [...filteredData].sort((a, b) =>
            new Date(a.DateString) - new Date(b.DateString)
        );

        const chartData = sortedData.map(item => ({
            date: item.DateString,
            totalAmount: item.totalamount || 0,
            subtractAmount: item.subtractamount || 0,
            totalUsers: item.orgId?.total_users || item.orgId?.totalUsers || 0,
            orgName: item.orgId?.org_name || item.orgId?.orgName || 'N/A',
            rawData: item
        }));

        const balances = chartData.map(d => d.totalAmount);
        const maxBalance = balances.length > 0 ? Math.max(...balances) : 0;
        const minBalance = balances.length > 0 ? Math.min(...balances) : 0;
        const avgBalance = balances.length > 0 ? Math.round(balances.reduce((a, b) => a + b, 0) / balances.length) : 0;

        const recentTransactions = [...sortedData].reverse().slice(0, 5);

        setWalletStats({
            maxBalance,
            minBalance,
            avgBalance,
            totalTransactions: chartData.length,
            recentTransactions
        });

        console.log("Chart data prepared:", chartData);
        return chartData;
    }, []);

    const WalletBalanceTooltip = ({ active, payload, label }) => {

        if (active && payload && payload.length) {
            const data = payload[0]?.payload;

            if (!data) return null;

            return (
                <div style={{
                    backgroundColor: styles.tooltipBg,
                    border: `1px solid ${styles.tooltipBorder}`,
                    borderRadius: '0.5rem',
                    padding: '12px 16px',
                    color: styles.tooltipText,
                    fontSize: '13px',
                    minWidth: '200px'
                }}>
                    <p style={{ marginBottom: 8, fontWeight: 600, color: isDark ? '#93c5fd' : '#2563eb', borderBottom: `1px solid ${styles.tooltipBorder}`, paddingBottom: 4 }}>
                        {label ? new Date(label).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric"
                        }) : 'No Date'}
                    </p>
                    <p style={{ margin: '4px 0', color: isDark ? '#60a5fa' : '#2563eb' }}>
                        Total Users: <strong>{data.subtractAmount || 0}</strong>
                    </p>
                    <p style={{ margin: '4px 0', color: isDark ? '#f87171' : '#dc2626' }}>
                        Subtracted Amount: <strong>-₹{(data.subtractAmount || 0).toLocaleString('en-IN')}</strong>
                    </p>
                    <p style={{ margin: '4px 0', color: isDark ? '#34d399' : '#059669' }}>
                        Current Balance: <strong>₹{(data.totalAmount || 0).toLocaleString('en-IN')}</strong>
                    </p>
                    {data.orgName && data.orgName !== 'N/A' && (
                        <p style={{ margin: '4px 0', color: isDark ? '#c084fc' : '#9333ea', fontSize: '11px', borderTop: `1px solid ${styles.tooltipBorder}`, marginTop: 6, paddingTop: 4 }}>
                            Org: {data.orgName}
                        </p>
                    )}
                </div>
            );
        }
        return null;
    };

   const fetchWalletBalance = useCallback(async () => {
    try {
        const res = await dispatch(GetWalletTracking());
        console.log("wallet tracking...", res);

        const walletData = res?.data?.data || res?.payload?.data || res;

        if (walletData && Array.isArray(walletData)) {
            const filtered = walletData.filter(item => {
                const itemDate = item.DateString?.split('T')[0];
                return itemDate >= dateRange.from && itemDate <= dateRange.to;
            });

            const ascendingData = [...filtered].sort((a, b) =>
                new Date(a.DateString) - new Date(b.DateString)
            );

            const chartData = ascendingData.map(item => ({
                date: item.DateString,
                totalAmount: item.totalamount,
                subtractAmount: item.subtractamount,
                totalUsers: item.orgId?.total_users,
                orgName: item.orgId?.org_name
            }));

            setWalletHistoryData(chartData);

            const descendingData = [...filtered].sort((a, b) =>
                new Date(b.DateString) - new Date(a.DateString)
            );

            setWalletStats({
                recentTransactions: descendingData
            });
        }
    } catch (error) {
        console.error("Error:", error);
    }
},[dateRange.from, dateRange.to, dispatch]);

    const fetchInitialData = useCallback(async () => {
     setLoading(true);
     try {
      const promises = [
      userDetails?.role === ACCOUNT_TYPE.MANAGER ? dispatch(Get_Devices(token)) : dispatch(Get_Org_Devices(token)),
      userDetails?.role === ACCOUNT_TYPE.MANAGER ? dispatch(Get_Managers_User(token)) : dispatch(Get_Users(token)),
      userDetails?.role === ACCOUNT_TYPE.MANAGER
        ? dispatch(Get_Attendance('All', dateRange.from, dateRange.to))
        : dispatch(Get_Attendance_Org('All', dateRange.from, dateRange.to))
      ];

     if (userDetails?.role !== ACCOUNT_TYPE.MANAGER) {
      promises.push(dispatch(Get_Managers(token)));
     }

     await Promise.all(promises);
     await fetchWalletBalance(dispatch, setLoading);
     setInitialLoad(false);
     } catch (error) {
     console.error("Error fetching dashboard data:", error);
     setInitialLoad(false);
     } finally {
     setLoading(false);
     }
// Include every state, prop, and hook used inside this function
    }, [userDetails, token, dateRange, dispatch, fetchWalletBalance]);


   useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

   useEffect(() => {
        if (!initialLoad) {
            fetchWalletBalance();
        }
   }, [dateRange, initialLoad, fetchWalletBalance]);

      const generateDailyUserStats = useCallback((attendance, employees) => {
    console.log("attendance data for analysis", attendance)

    const uniqueMap = new Map()
        ;(attendance || []).forEach(record => {
            const dateKey = toLocalDateKey(record.DateString)
            const userId = record.User_Id
            if (!dateKey || !userId) return
            const key = `${userId}_${dateKey}`
            if (!uniqueMap.has(key)) {
                uniqueMap.set(key, { ...record, _dateKey: dateKey })
            } else {
                const existing = uniqueMap.get(key)
                if (record.status === 'P' && existing.status !== 'P') {
                    uniqueMap.set(key, { ...record, _dateKey: dateKey })
                }
            }
        })

        const totalUsersByDate = new Map()
        const presentByDate = new Map()
        const absentByDate = new Map()
        const lateByDate = new Map()
        const onTimeByDate = new Map()

        uniqueMap.forEach(record => {
            const dk = record._dateKey

            if (record.total_users != null) {
                totalUsersByDate.set(dk, Number(record.total_users))
            }

            if (record.status === 'P') {
                presentByDate.set(dk, (presentByDate.get(dk) || 0) + 1)

                const [h = '0', m = '0'] = (record.Late_In || '00:00:00').split(':')
                const lateMinutes = parseInt(h) * 60 + parseInt(m)

                if (lateMinutes > 0) {
                    lateByDate.set(dk, (lateByDate.get(dk) || 0) + 1)
                } else {
                    onTimeByDate.set(dk, (onTimeByDate.get(dk) || 0) + 1)
                }
            }

            if (record.status === 'A') {
                absentByDate.set(dk, (absentByDate.get(dk) || 0) + 1)
            }
        })

        return getCalendarDays(dateRange.from, dateRange.to).map(dk => {
            const totalEmployees = totalUsersByDate.get(dk) || 0
            const present = presentByDate.get(dk) || 0
            const absent = absentByDate.get(dk) || 0
            const late = lateByDate.get(dk) || 0
            const onTime = onTimeByDate.get(dk) || 0

            return {
                date: dk,
                present,
                absent,
                active: present + absent,
                inactive: totalEmployees - (present + absent),
                late,
                onTime,
                total: totalEmployees
            }
        })
   }, [dateRange.from, dateRange.to, getCalendarDays, toLocalDateKey]);


      const generateTrendData = useCallback((attendance) => {
        if (!attendance || attendance.length === 0) return [];
        const dateMap = new Map();
        const sortedAttendance = [...attendance].sort((a, b) => new Date(a.DateString) - new Date(b.DateString));
        sortedAttendance.forEach(record => {
            const date = toLocalDateKey(record.DateString);
            if (!date) return;
            if (!dateMap.has(date)) {
                dateMap.set(date, {
                    date,
                    present: 0,
                    earlyIn: 0,
                    lateIn: 0,
                    earlyOut: 0,
                    lateOut: 0,
                    undertime: 0,
                    overtime: 0
                });
            }
            const dayData = dateMap.get(date);

            if (record.status === 'P') {
                dayData.present += 1;
            }

            const earlyInMinutes = parseInt(record.Erly_In?.split(':')[0] || '0') * 60 + parseInt(record.Erly_In?.split(':')[1] || '0');
            if (earlyInMinutes > 0) {
                dayData.earlyIn += 1;
            }

            const lateInMinutes = parseInt(record.Late_In?.split(':')[0] || '0') * 60 + parseInt(record.Late_In?.split(':')[1] || '0');
            if (lateInMinutes > 0) {
                dayData.lateIn += 1;
            }

            const earlyOutValue = record?.Err_Out || record?.Erl_Out || '00:00:00';
            const earlyOutMinutes = parseInt(earlyOutValue?.split(':')[0] || '0') * 60 + parseInt(earlyOutValue?.split(':')[1] || '0');
            if (earlyOutMinutes > 0) {
                dayData.earlyOut += 1;
            }

            const lateOutMinutes = parseInt(record.Late_Out?.split(':')[0] || '0') * 60 + parseInt(record.Late_Out?.split(':')[1] || '0');
            if (lateOutMinutes > 0) {
                dayData.lateOut += 1;
            }

            const undertimeMinutes = parseInt(record.Under_Time?.split(':')[0] || '0') * 60 + parseInt(record.Under_Time?.split(':')[1] || '0');
            if (undertimeMinutes > 0) {
                dayData.undertime += 1;
            }

            const overtimeMinutes = parseInt(record.Over_Time?.split(':')[0] || '0') * 60 + parseInt(record.Over_Time?.split(':')[1] || '0');
            if (overtimeMinutes > 0) {
                dayData.overtime += 1;
            }
        });

        return Array.from(dateMap.values()).sort((a, b) => new Date(a.date) - new Date(b.date));
    },[toLocalDateKey]);


    const processDashboardData = useCallback(() => {
        const onlineDevices = devicesData.filter(d => d?.last_status === 'ONLINE' || d?.last_status === 'HEARTBEAT').length;
        const offlineDevices = devicesData.filter(d => d?.last_status === 'OFFLINE').length;
        const activeEmployees = employeesData.filter(e => e?.status === 'ACTIVE').length;
        const deactiveEmployees = employeesData.filter(e => e?.status === 'DEACTIVE').length;
        const activeManagers = managersData.filter(m => m?.status === true).length;
        const deactiveManagers = managersData.filter(m => m?.status === false).length;

        // Calculate attendance metrics based on the actual data
        let earlyInCount = 0;
        let lateInCount = 0;
        let earlyOutCount = 0;
        let lateOutCount = 0;
        let undertimeCount = 0;
        let overtimeCount = 0;
        let presentCount = 0;

        attendanceData.forEach(a => {
            // Check Early In (Erly_In > 0)
            const earlyInMinutes = parseInt(a?.Erly_In?.split(':')[0] || '0') * 60 + parseInt(a?.Erly_In?.split(':')[1] || '0');
            if (earlyInMinutes > 0) earlyInCount++;

            // Check Late In (Late_In > 0)
            const lateInMinutes = parseInt(a?.Late_In?.split(':')[0] || '0') * 60 + parseInt(a?.Late_In?.split(':')[1] || '0');
            if (lateInMinutes > 0) lateInCount++;

            // Check Early Out (Err_Out or Erl_Out > 0)
            const earlyOutValue = a?.Err_Out || a?.Erl_Out || '00:00:00';
            const earlyOutMinutes = parseInt(earlyOutValue?.split(':')[0] || '0') * 60 + parseInt(earlyOutValue?.split(':')[1] || '0');
            if (earlyOutMinutes > 0) earlyOutCount++;

            // Check Late Out (Late_Out > 0)
            const lateOutMinutes = parseInt(a?.Late_Out?.split(':')[0] || '0') * 60 + parseInt(a?.Late_Out?.split(':')[1] || '0');
            if (lateOutMinutes > 0) lateOutCount++;

            // Check Undertime (Under_Time > 0)
            const undertimeMinutes = parseInt(a?.Under_Time?.split(':')[0] || '0') * 60 + parseInt(a?.Under_Time?.split(':')[1] || '0');
            if (undertimeMinutes > 0) undertimeCount++;

            // Check Overtime (Over_Time > 0)
            const overtimeMinutes = parseInt(a?.Over_Time?.split(':')[0] || '0') * 60 + parseInt(a?.Over_Time?.split(':')[1] || '0');
            if (overtimeMinutes > 0) overtimeCount++;

            // Check Present
            if (a?.status === 'P') presentCount++;
        });

        const totalEmployees = employeesData.length || 0;

        setStats({
            devices: { total: devicesData.length || 0, online: onlineDevices, offline: offlineDevices },
            employees: { total: totalEmployees, active: activeEmployees, deactive: deactiveEmployees },
            managers: { total: managersData.length || 0, active: activeManagers, deactive: deactiveManagers },
            attendance: { 
                earlyIn: earlyInCount, 
                lateIn: lateInCount, 
                earlyOut: earlyOutCount, 
                lateOut: lateOutCount, 
                present: presentCount, 
                undertime: undertimeCount, 
                overtime: overtimeCount, 
                total: attendanceData.length || 0 
            }
        });

        const trendData = generateTrendData(attendanceData);
        setAttendanceTrend(trendData);

        const deviceActivityData = devicesData.map(device => ({
            name: device?.device_name || 'Unknown',
            users: device?.users_count || 0,
            status: device?.last_status || 'OFFLINE',
            location: device?.device_location || 'Unknown',
            last_seen: device?.device_last_seen || new Date().toISOString()
        }));
        setDeviceActivity(deviceActivityData);

        const deptStats = generateDepartmentStats(employeesData, attendanceData);
        setDepartmentStats(deptStats);

        const dailyStats = generateDailyUserStats(attendanceData, employeesData);
        setDailyUserStats(dailyStats);
    }, [devicesData, employeesData, managersData, attendanceData, generateDailyUserStats, generateTrendData]);

     useEffect(() => {
        if (!initialLoad && (devicesData.length > 0 || employeesData.length > 0 || managersData.length > 0 || attendanceData.length > 0)) {
            processDashboardData();
        }
    }, [devicesData, employeesData, managersData, attendanceData, initialLoad, processDashboardData]);


    console.log("dailyuserstat", dailyUserStats)

    useEffect(() => {
        if (!initialLoad && attendanceData.length > 0) {
            const trendData = generateTrendData(attendanceData);
            setAttendanceTrend(trendData);
        }
    }, [attendanceData, initialLoad, generateTrendData]);

    const generateDepartmentStats = (employees, attendance) => {
        if (!employees || employees.length === 0) return [];
        const deptMap = new Map();
        employees.forEach(emp => {
            const dept = emp?.user_department || 'Other';
            if (!deptMap.has(dept)) {
                deptMap.set(dept, { name: dept, total: 0, active: 0, present: 0 });
            }
            const deptData = deptMap.get(dept);
            deptData.total += 1;
            deptData.active += emp?.status === 'ACTIVE' ? 1 : 0;
        });
        if (attendance && attendance.length > 0) {
            attendance.forEach(record => {
                const emp = employees.find(e => e?._id === record?.User_Id);
                if (emp) {
                    const dept = emp?.user_department || 'Other';
                    const deptData = deptMap.get(dept);
                    if (deptData && record?.status === 'P') {
                        deptData.present += 1;
                    }
                }
            });
        }
        return Array.from(deptMap.values());
    };



    const handleDateChange = (type, value) => {
        setDateRange(prev => ({ ...prev, [type]: value }));
    };

    const handleRefresh = () => {
        fetchInitialData();
    };

    const COLORS = {
        online: '#10b981', offline: '#ef4444', active: '#3b82f6',
        deactive: '#9ca3af', late: '#f59e0b', earlyout: '#8b5cf6',
        overtime: '#ec4899', present: '#10b981'
    };

    // const DARK_BLUE_COLORS = isDark? ['#2563eb', '#3b82f6', '#60a5fa', '#93c5fd', '#bfdbfe']: ['#1d4ed8', '#2563eb', '#3b82f6', '#60a5fa', '#93c5fd'];
    // eslint-disable-next-line
    const DailyUserTooltip = ({ active, payload, label }) => {
        console.log("tooltip payload...", payload)
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: styles.tooltipBg, border: `1px solid ${styles.tooltipBorder}`, borderRadius: '0.5rem', padding: '10px 14px', color: styles.tooltipText, fontSize: '13px' }}>
                    <p style={{ marginBottom: 6, fontWeight: 600 }}>
                        {new Date(label).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                    </p>
                    {payload.map((entry, i) => {
                        let color = entry.fill;
                        let displayName = entry.name;
                        if (entry.name === 'onTime') displayName = 'On Time';
                        if (entry.name === 'late') displayName = 'Late';
                        if (entry.name === 'absent') displayName = 'Absent';
                        if (entry.name === 'inactive') displayName = 'Inactive';
                        return (
                            <p key={i} style={{ color: color, margin: '2px 0' }}>
                                {displayName}: <strong>{entry.value}</strong>
                            </p>
                        );
                    })}
                    <p style={{ marginTop: 6, color: isDark ? '#93c5fd' : '#2563eb', borderTop: `1px solid ${styles.tooltipBorder}`, paddingTop: 4 }}>
                        Total: <strong>{payload.reduce((sum, entry) => sum + entry.value, 0)}</strong>
                    </p>
                </div>
            );
        }
        return null;
    };

    if (loading && initialLoad) {
        return (
            <div className={`flex items-center justify-center min-h-screen bg-gradient-to-br ${styles.pageBg}`}>
                <div className="text-center">
                    <RefreshCw className={`w-12 h-12 mx-auto mb-4 animate-spin ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                    <p className={styles.textMuted}>Loading dashboard data...</p>
                </div>
            </div>
        );
    }

    return (
        <div className={`min-h-screen pb-8 bg-gradient-to-br ${styles.pageBg}`}>
            {/* Header */}
            <div className={`sticky -top-4 z-10 border-b backdrop-blur-sm ${styles.headerBg}`}>
                <div className="px-4 py-2 mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                        <div className="flex items-center space-x-4">
                            <div>
                                <h1 className={`text-3xl font-bold ${styles.textPrimary}`}>Overview Dashboard</h1>
                                <p className={`mt-1 ${styles.textSecondary}`}>Real-time analysis</p>
                            </div>
                            <button
                                onClick={handleRefresh}
                                className={`p-2 transition-colors rounded-lg ${styles.refreshBtn}`}
                                title="Refresh Data"
                            >
                                <RefreshCw className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
                            </button>
                        </div>
                        <div className="flex items-center mt-4 space-x-4 md:mt-0">
                            <div className="flex items-center space-x-2">
                                <input
                                    type="date"
                                    value={dateRange.from}
                                    onChange={(e) => handleDateChange('from', e.target.value)}
                                    className={`px-3 py-2 text-sm border rounded-lg date-input focus:outline-none focus:border-blue-600 ${styles.inputBg}`}
                                    max={dateRange.to}
                                />
                                <span className={styles.textMuted}>to</span>
                                <input
                                    type="date"
                                    value={dateRange.to}
                                    onChange={(e) => handleDateChange('to', e.target.value)}
                                    className={`px-3 py-2 text-sm border rounded-lg date-input focus:outline-none focus:border-blue-600 ${styles.inputBg}`}
                                    min={dateRange.from}
                                    max={new Intl.DateTimeFormat('en-CA', {
                                        timeZone: 'Pacific/Kiritimati',
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                    }).format(new Date())}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="px-3 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8 sm:py-6 lg:py-8">
                {/* Stats Cards */}
                <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-2 lg:grid-cols-4 sm:gap-6 lg:mb-8">
                    <StatCard icon={Monitor} title="Total Devices" value={stats.devices.total} accent="cyan" isDark={isDark}>
                        <div className="flex items-center justify-between mt-3 space-x-2 sm:space-x-4">
                            <div className="flex items-center space-x-1 sm:-ml-2">
                                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                                <span className={`text-xs sm:text-sm ${styles.statChipText}`}>{stats.devices.online} Online</span>
                            </div>
                            <div className="flex items-center space-x-1">
                                <div className="w-2 h-2 bg-red-400 rounded-full"></div>
                                <span className={`text-xs sm:text-sm ${styles.statChipText}`}>{stats.devices.offline} Offline</span>
                            </div>
                        </div>
                    </StatCard>

                    <StatCard icon={Users} title="Total Employees" value={stats.employees.total} accent="purple" isDark={isDark}>
                        <div className="flex items-center justify-between mt-3 space-x-2 sm:space-x-1">
                            <div className="flex items-center space-x-1 sm:-ml-2">
                                <UserCheck className="w-3 h-3 text-green-400 sm:w-4 sm:h-4" />
                                <span className={`text-xs sm:text-sm ${styles.statChipText}`}>{stats.employees.active} Active</span>
                            </div>
                            <div className="flex items-center space-x-1">
                                <UserX className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-gray-300' : 'text-slate-400'}`} />
                                <span className={`text-xs sm:text-sm ${styles.statChipText}`}>{stats.employees.deactive} Inactive</span>
                            </div>
                        </div>
                    </StatCard>

                    {userDetails?.role !== ACCOUNT_TYPE.MANAGER && (
                        <StatCard icon={UserCheck} title="Total Managers" value={stats.managers.total} accent="indigo" isDark={isDark}>
                            <div className="flex items-center justify-between mt-3 space-x-2 sm:space-x-4">
                                <div className="flex items-center space-x-1 sm:space-x-2">
                                    <UserCheck className="w-3 h-3 text-green-400 sm:w-4 sm:h-4" />
                                    <span className={`text-xs sm:text-sm ${styles.statChipText}`}>{stats.managers.active} Active</span>
                                </div>
                                <div className="flex items-center space-x-1 sm:space-x-2">
                                    <UserX className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-gray-300' : 'text-slate-400'}`} />
                                    <span className={`text-xs sm:text-sm ${styles.statChipText}`}>{stats.managers.deactive} Inactive</span>
                                </div>
                            </div>
                        </StatCard>
                    )}

                    <StatCard icon={Calendar} title="Attendance" value={stats.attendance.present} accent="green" isDark={isDark}>
                        <div className={`mt-2 text-xs sm:mt-3 sm:text-sm ${styles.statChipText}`}>
                            Out of {stats.employees.total} employees
                        </div>
                    </StatCard>

                    {userDetails?.role === ACCOUNT_TYPE.MANAGER && (
                        <StatCard icon={Timer} title="Overtime" value={stats.attendance.overtime} accent="pink" isDark={isDark}>
                            <div className={`mt-2 text-xs sm:mt-3 sm:text-sm ${styles.statChipText}`}>Employees working extra</div>
                        </StatCard>
                    )}
                </div>

                {/* Attendance Analytics Cards - Early In, Late In, Early Out, Late Out, Undertime, Overtime */}
                {/* <div className="grid grid-cols-2 gap-3 mb-6 sm:grid-cols-3 lg:grid-cols-6 sm:gap-4 lg:mb-8">
                    <div className={`p-3 border rounded-xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs sm:text-sm ${styles.textMuted}`}>Early In</span>
                            <div className={`p-1.5 rounded-lg ${isDark ? 'bg-green-400/20' : 'bg-green-100'}`}>
                                <UserCheck className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
                            </div>
                        </div>
                        <p className="mt-2 text-lg font-bold text-green-500 sm:text-2xl">{stats.attendance.earlyIn}</p>
                    </div>

                    <div className={`p-3 border rounded-xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs sm:text-sm ${styles.textMuted}`}>Late In</span>
                            <div className={`p-1.5 rounded-lg ${isDark ? 'bg-yellow-400/20' : 'bg-yellow-100'}`}>
                                <AlertCircle className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-yellow-400' : 'text-yellow-600'}`} />
                            </div>
                        </div>
                        <p className="mt-2 text-lg font-bold text-yellow-500 sm:text-2xl">{stats.attendance.lateIn}</p>
                    </div>

                    <div className={`p-3 border rounded-xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs sm:text-sm ${styles.textMuted}`}>Early Out</span>
                            <div className={`p-1.5 rounded-lg ${isDark ? 'bg-purple-400/20' : 'bg-purple-100'}`}>
                                <Clock className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-purple-400' : 'text-purple-600'}`} />
                            </div>
                        </div>
                        <p className="mt-2 text-lg font-bold text-purple-500 sm:text-2xl">{stats.attendance.earlyOut}</p>
                    </div>

                    <div className={`p-3 border rounded-xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs sm:text-sm ${styles.textMuted}`}>Late Out</span>
                            <div className={`p-1.5 rounded-lg ${isDark ? 'bg-red-400/20' : 'bg-red-100'}`}>
                                <Clock className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
                            </div>
                        </div>
                        <p className="mt-2 text-lg font-bold text-red-500 sm:text-2xl">{stats.attendance.lateOut}</p>
                    </div>

                    <div className={`p-3 border rounded-xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs sm:text-sm ${styles.textMuted}`}>Undertime</span>
                            <div className={`p-1.5 rounded-lg ${isDark ? 'bg-orange-400/20' : 'bg-orange-100'}`}>
                                <Timer className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
                            </div>
                        </div>
                        <p className="mt-2 text-lg font-bold text-orange-500 sm:text-2xl">{stats.attendance.undertime}</p>
                    </div>

                    <div className={`p-3 border rounded-xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs sm:text-sm ${styles.textMuted}`}>Overtime</span>
                            <div className={`p-1.5 rounded-lg ${isDark ? 'bg-pink-400/20' : 'bg-pink-100'}`}>
                                <TrendingUp className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-pink-400' : 'text-pink-600'}`} />
                            </div>
                        </div>
                        <p className="mt-2 text-lg font-bold text-pink-500 sm:text-2xl">{stats.attendance.overtime}</p>
                    </div>
                </div> */}

                {/* Charts Row 1 */}
                <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-2 sm:gap-6 lg:mb-8">
                    <div className={`p-4 border sm:p-6 backdrop-blur-sm rounded-2xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between mb-4 sm:mb-6">
                            <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Device Status</h2>
                            <Activity className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                        </div>
                        {stats.devices.total > 0 ? (
                            <>
                                <div className="h-48 sm:h-56 md:h-64">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart>
                                            <Pie
                                                data={[
                                                    { name: 'Online', value: stats.devices.online },
                                                    { name: 'Offline', value: stats.devices.offline }
                                                ]}
                                                cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value"
                                            >
                                                <Cell fill={COLORS.online} />
                                                <Cell fill={COLORS.offline} />
                                            </Pie>
                                            <Tooltip contentStyle={{ backgroundColor: styles.tooltipBg, border: `1px solid ${styles.tooltipBorder}`, borderRadius: '0.5rem', color: styles.tooltipText, fontSize: '12px' }} />
                                            <Legend wrapperStyle={{ fontSize: '12px' }} formatter={(value) => <span className={`text-xs sm:text-sm ${styles.textAccent}`}>{value}</span>} />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="grid grid-cols-2 gap-3 mt-4 sm:gap-4">
                                    <div className={`p-2 text-center sm:p-3 rounded-xl ${styles.innerBg}`}>
                                        <div className="text-xl font-bold text-green-400 sm:text-2xl">{stats.devices.online}</div>
                                        <div className={`text-xs sm:text-sm ${styles.textMuted}`}>Online</div>
                                    </div>
                                    <div className={`p-2 text-center sm:p-3 rounded-xl ${styles.innerBg}`}>
                                        <div className="text-xl font-bold text-red-400 sm:text-2xl">{stats.devices.offline}</div>
                                        <div className={`text-xs sm:text-sm ${styles.textMuted}`}>Offline</div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="flex items-center justify-center h-48 sm:h-64">
                                <p className={`text-sm sm:text-base ${styles.textMuted}`}>No device data available</p>
                            </div>
                        )}
                    </div>

                    <div className={`p-4 border sm:p-6 backdrop-blur-sm rounded-2xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between mb-4 sm:mb-6">
                            <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>
                                {userDetails?.role !== ACCOUNT_TYPE.MANAGER ? 'Employee & Manager Status' : 'Employee Status'}
                            </h2>
                            <Users className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                        </div>
                        {stats.employees.total > 0 ? (
                            <div className="h-64 sm:h-80 lg:h-96">
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={
                                        userDetails?.role !== ACCOUNT_TYPE.MANAGER
                                            ? [
                                                { name: 'Employees Active', value: stats.employees.active },
                                                { name: 'Employees Inactive', value: stats.employees.deactive },
                                                { name: 'Managers Active', value: stats.managers.active },
                                                { name: 'Managers Inactive', value: stats.managers.deactive }
                                            ]
                                            : [
                                                { name: 'Active', value: stats.employees.active },
                                                { name: 'Inactive', value: stats.employees.deactive }
                                            ]
                                    }>
                                        <CartesianGrid strokeDasharray="3 3" stroke={styles.gridStroke} />
                                        <XAxis
                                            dataKey="name"
                                            stroke={styles.axisStroke}
                                            angle={-35}
                                            textAnchor="end"
                                            height={70}
                                            tick={{ fontSize: 10, fill: styles.axisTick }}
                                            interval={0}
                                        />
                                        <YAxis stroke={styles.axisStroke} tick={{ fontSize: 11, fill: styles.axisTick }} />
                                        <Tooltip contentStyle={{ backgroundColor: styles.tooltipBg, border: `1px solid ${styles.tooltipBorder}`, borderRadius: '0.5rem', color: styles.tooltipText, fontSize: '12px' }} />
                                        <Bar dataKey="value" fill="#3b82f6" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        ) : (
                            <div className="flex items-center justify-center h-48 sm:h-64">
                                <p className={`text-sm sm:text-base ${styles.textMuted}`}>No employee data available</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Charts Row 2 - Attendance Analytics Chart */}
                <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-2 sm:gap-6 lg:mb-8">
                    <div className={`p-4 border sm:p-6 backdrop-blur-sm rounded-2xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between mb-4 sm:mb-6">
                            <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Attendance Analytics</h2>
                            <Clock className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                        </div>
                        {stats.attendance.total > 0 ? (
                            <div className="h-64 sm:h-72 md:h-80">
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={[
                                        { name: 'Early In', value: stats.attendance.earlyIn, fill: '#22c55e' },
                                        { name: 'Late In', value: stats.attendance.lateIn, fill: '#eab308' },
                                        { name: 'Early Out', value: stats.attendance.earlyOut, fill: '#a855f7' },
                                        { name: 'Late Out', value: stats.attendance.lateOut, fill: '#ef4444' },
                                        { name: 'Undertime', value: stats.attendance.undertime, fill: '#f97316' },
                                        { name: 'Overtime', value: stats.attendance.overtime, fill: '#ec4899' }
                                    ]}>
                                        <CartesianGrid strokeDasharray="3 3" stroke={styles.gridStroke} />
                                        <XAxis 
                                            dataKey="name" 
                                            stroke={styles.axisStroke} 
                                            tick={{ fontSize: 11, fill: styles.axisTick }}
                                            angle={-25}
                                            textAnchor="end"
                                            height={60}
                                        />
                                        <YAxis stroke={styles.axisStroke} tick={{ fontSize: 11, fill: styles.axisTick }} />
                                        <Tooltip contentStyle={{ backgroundColor: styles.tooltipBg, border: `1px solid ${styles.tooltipBorder}`, borderRadius: '0.5rem', color: styles.tooltipText, fontSize: '12px' }} />
                                        <Bar dataKey="value" name="Count" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        ) : (
                            <div className="flex items-center justify-center h-48 sm:h-64">
                                <p className={`text-sm text-center sm:text-base ${styles.textMuted}`}>No attendance data available for selected date range</p>
                            </div>
                        )}
                    </div>

                    {/* Department Distribution - Just different colors, same style */}
                    <div className={`p-4 border sm:p-6 backdrop-blur-sm rounded-2xl ${styles.cardBg}`}>
                        <div className="flex items-center justify-between mb-4 sm:mb-6">
                            <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Department Distribution</h2>
                            <ChartPie className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                        </div>
                        {departmentStats.length > 0 ? (
                            <div className="h-48 sm:h-56 md:h-72">
                                <ResponsiveContainer width="100%" height="100%">
                                    <PieChart>
                                        <Pie 
                                            data={departmentStats} 
                                            cx="50%" 
                                            cy="50%" 
                                            outerRadius={70} 
                                            dataKey="total" 
                                            nameKey="name" 
                                            label={({ name, percent }) => window.innerWidth > 640 ? `${name}: ${(percent * 100).toFixed(0)}%` : ''}
                                        >
                                            {departmentStats.map((entry, index) => (
                                                <Cell 
                                                    key={`cell-${index}`} 
                                                    fill={DEPARTMENT_COLORS[index % DEPARTMENT_COLORS.length]} 
                                                />
                                            ))}
                                        </Pie>
                                        <Tooltip 
                                            contentStyle={{ 
                                                backgroundColor: styles.tooltipBg, 
                                                border: `1px solid ${styles.tooltipBorder}`, 
                                                borderRadius: '0.5rem', 
                                                color: styles.tooltipText, 
                                                fontSize: '12px' 
                                            }}
                                        />
                                        <Legend 
                                            wrapperStyle={{ fontSize: '11px' }} 
                                            formatter={(value) => <span className={`text-xs sm:text-sm ${styles.textAccent}`}>{value}</span>} 
                                        />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        ) : (
                            <div className="flex items-center justify-center h-48 sm:h-64">
                                <p className={`text-sm sm:text-base ${styles.textMuted}`}>No department data available</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Attendance Trend - COMMENTED OUT */}
                
                <div className={`p-4 mb-6 border sm:p-6 backdrop-blur-sm rounded-2xl sm:mb-8 ${styles.cardBg}`}>
                    <div className="flex items-center justify-between mb-4 sm:mb-6">
                        <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Attendance Trend</h2>
                        <TrendingUp className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                    </div>
                    {attendanceTrend.length > 0 ? (
                        <div className="h-64 sm:h-72 md:h-80">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={attendanceTrend}>
                                    <CartesianGrid strokeDasharray="3 3" stroke={styles.gridStroke} />
                                    <XAxis
                                        dataKey="date"
                                        stroke={styles.axisStroke}
                                        tickFormatter={(value) =>
                                            new Date(value + 'T12:00:00').toLocaleDateString("en-IN", {
                                                timeZone: orgTimezone, day: "2-digit", month: "short"
                                            })
                                        }
                                        tick={{ fontSize: 10, fill: styles.axisTick }}
                                        interval="preserveStartEnd"
                                    />
                                    <YAxis stroke={styles.axisStroke} tick={{ fontSize: 11, fill: styles.axisTick }} />
                                    <Tooltip contentStyle={{ backgroundColor: styles.tooltipBg, border: `1px solid ${styles.tooltipBorder}`, borderRadius: '0.5rem', color: styles.tooltipText, fontSize: '12px' }} />
                                    <Legend wrapperStyle={{ fontSize: '11px' }} formatter={(value) => <span className={`text-xs sm:text-sm ${styles.textAccent}`}>{value}</span>} />
                                    <Line type="monotone" dataKey="present" stroke="#10b981" strokeWidth={2} dot={{ r: 3 }} />
                                    <Line type="monotone" dataKey="late" stroke="#f59e0b" strokeWidth={2} dot={{ r: 3 }} />
                                    <Line type="monotone" dataKey="earlyOut" stroke="#8b5cf6" strokeWidth={2} dot={{ r: 3 }} />
                                    <Line type="monotone" dataKey="overtime" stroke="#ec4899" strokeWidth={2} dot={{ r: 3 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center h-48 sm:h-64">
                            <p className={`text-sm sm:text-base ${styles.textMuted}`}>No trend data available for selected date range</p>
                        </div>
                    )}
                </div>
               

                {/* Daily User Analysis */}
                {/* <div className={`p-4 mb-6 border sm:p-6 backdrop-blur-sm rounded-2xl sm:mb-8 ${styles.cardBg}`}>
                    <div className="flex flex-col mb-4 space-y-2 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:mb-6">
                        <div>
                            <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Daily User Analysis</h2>
                            <p className={`text-xs sm:text-sm ${styles.textMutedFaint}`}>Per-day breakdown of OnTime, Late, Absent, Inactive &amp; Total users</p>
                        </div>
                        <BarChart2 className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                    </div>

                    <div className="flex flex-wrap gap-2 mt-2 mb-4 sm:gap-3 sm:mb-6">
                        {[
                            { color: '#22c55e', label: 'On Time' },
                            { color: '#eab308', label: 'Late' },
                            { color: '#ef4444', label: 'Absent' },
                            { color: '#9ca3af', label: 'Inactive' },
                        ].map(item => (
                            <div key={item.label} className={`flex items-center px-2 py-1 space-x-1 border rounded-full sm:px-3 sm:py-1 sm:space-x-2 ${styles.innerBg} ${styles.borderSoft}`}>
                                <div className="w-2 h-2 rounded-full sm:w-3 sm:h-3" style={{ backgroundColor: item.color }}></div>
                                <span className={`text-xs sm:text-sm ${styles.textAccent}`}>{item.label}</span>
                            </div>
                        ))}
                    </div>

                    {dailyUserStats.length > 0 ? (
                        <div className="h-64 -mb-8 sm:h-80 md:h-96 sm:-mb-10">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={dailyUserStats} margin={{ top: 10, right: 10, left: 0, bottom: 50 }} barCategoryGap="15%" barGap={2}>
                                    <CartesianGrid strokeDasharray="3 3" stroke={styles.gridStroke} />
                                    <XAxis
                                        dataKey="date"
                                        stroke={styles.axisStroke}
                                        tick={{ fill: styles.axisTick, fontSize: 9 }}
                                        tickFormatter={(value) =>
                                            new Date(value + 'T12:00:00').toLocaleDateString("en-IN", {
                                                timeZone: orgTimezone, day: "2-digit", month: "short"
                                            })
                                        }
                                        angle={-45}
                                        textAnchor="end"
                                        height={60}
                                        interval={dailyUserStats.length > 10 ? Math.floor(dailyUserStats.length / 10) : 0}
                                    />
                                    <YAxis
                                        stroke={styles.axisStroke}
                                        tick={{ fill: styles.axisTick, fontSize: 10 }}
                                        allowDecimals={false}
                                        label={{ value: 'No. of Users', angle: -90, position: 'insideLeft', offset: 10, style: { fill: styles.axisTick, fontSize: 11 } }}
                                    />
                                    <Tooltip content={<DailyUserTooltip />} />
                                    <Legend wrapperStyle={{ fontSize: '11px' }} formatter={(value) => <span className={styles.textAccent}>{value}</span>} />
                                    <Bar dataKey="onTime" name="On Time" stackId="stack" fill="#22c55e" radius={[0, 0, 0, 0]} />
                                    <Bar dataKey="late" name="Late" stackId="stack" fill="#eab308" radius={[0, 0, 0, 0]} />
                                    <Bar dataKey="absent" name="Absent" stackId="stack" fill="#ef4444" radius={[0, 0, 0, 0]} />
                                    <Bar dataKey="inactive" name="Inactive" stackId="stack" fill="#9ca3af" radius={[4, 4, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center h-48 space-y-2 sm:h-64">
                            <BarChart2 className={`w-8 h-8 sm:w-10 sm:h-10 ${isDark ? 'text-blue-700' : 'text-blue-200'}`} />
                            <p className={`text-sm text-center sm:text-base ${styles.textMuted}`}>No data available for selected date range</p>
                        </div>
                    )}

                    {dailyUserStats.length > 0 && (
                        <div className="grid grid-cols-2 gap-2 mt-4 sm:grid-cols-5 sm:gap-3">
                            <div className={`p-2 text-center border sm:p-3 rounded-xl ${isDark ? 'bg-blue-600/20 border-blue-700/90' : 'bg-blue-100/20 border-blue-100'}`}>
                                <div className={`text-base font-bold sm:text-lg ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>{dailyUserStats[0]?.total ?? 0}</div>
                                <div className={`mt-1 text-[10px] sm:text-xs ${styles.textMuted}`}>Total Employees</div>
                            </div>
                            <div className={`p-2 text-center border sm:p-3 rounded-xl ${isDark ? 'bg-green-900/20 border-green-700/20' : 'bg-green-50 border-green-400'}`}>
                                <div className="text-base font-bold text-green-500 sm:text-lg">
                                    {dailyUserStats.length > 0 ? Math.round(dailyUserStats.reduce((s, d) => s + d.onTime, 0) / dailyUserStats.length) : 0}
                                </div>
                                <div className={`mt-1 text-[10px] sm:text-xs ${styles.textMuted}`}>Avg On Time / Day</div>
                            </div>
                            <div className={`p-2 text-center border sm:p-3 rounded-xl ${isDark ? 'bg-yellow-700/30 border-yellow-700/50' : 'bg-yellow-100/10 border-yellow-100'}`}>
                                <div className="text-base font-bold text-yellow-500 sm:text-lg">
                                    {dailyUserStats.length > 0 ? Math.round(dailyUserStats.reduce((s, d) => s + d.late, 0) / dailyUserStats.length) : 0}
                                </div>
                                <div className={`mt-1 text-[10px] sm:text-xs ${styles.textMuted}`}>Avg Late / Day</div>
                            </div>
                            <div className={`p-2 text-center border sm:p-3 rounded-xl ${isDark ? 'bg-red-900/20 border-red-700/20' : 'bg-red-100/10 border-red-300'}`}>
                                <div className="text-base font-bold text-red-500 sm:text-lg">
                                    {dailyUserStats.length > 0 ? Math.round(dailyUserStats.reduce((s, d) => s + d.absent, 0) / dailyUserStats.length) : 0}
                                </div>
                                <div className={`mt-1 text-[10px] sm:text-xs ${styles.textMuted}`}>Avg Absent / Day</div>
                            </div>
                            <div className={`p-2 text-center border sm:p-3 rounded-xl ${isDark ? 'bg-gray-700/20 border-gray-600/20' : 'bg-slate-100 border-slate-400'}`}>
                                <div className={`text-base font-bold sm:text-lg ${isDark ? 'text-gray-400' : 'text-slate-500'}`}>{dailyUserStats[0]?.inactive ?? 0}</div>
                                <div className={`mt-1 text-[10px] sm:text-xs ${styles.textMuted}`}>Inactive Employees</div>
                            </div>
                        </div>
                    )}
                </div> */}

                {/* Wallet Balance History - Daily Balance Tracking */}
                {userDetails.role === "Organization" && (
                    <div className={`p-4 mb-6 border sm:p-6 backdrop-blur-sm rounded-2xl sm:mb-8 ${styles.cardBg}`}>
                        <div className="flex flex-col mb-4 space-y-2 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:mb-6">
                            <div>
                                <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Wallet Balance History</h2>
                                <p className={`text-xs sm:text-sm ${styles.textMuted}`}>
                                    Daily balance tracking
                                </p>
                            </div>
                            <ChartLine className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                        </div>

                        {/* Wallet Balance Chart */}
                        {walletHistoryData.length > 0 ? (
                            <>
                                <div className="h-64 sm:h-72 md:h-80">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart data={walletHistoryData} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                                            <defs>
                                                <linearGradient id="walletGradient" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="5%" stopColor="#34d399" stopOpacity={0.3} />
                                                    <stop offset="95%" stopColor="#34d399" stopOpacity={0} />
                                                </linearGradient>
                                            </defs>
                                            <CartesianGrid strokeDasharray="3 3" stroke={styles.gridStroke} />
                                            <XAxis
                                                dataKey="date"
                                                stroke={styles.axisStroke}
                                                tick={{ fill: styles.axisTick, fontSize: 10 }}
                                                tickFormatter={(value) => {
                                                    const d = new Date(value);
                                                    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
                                                }}
                                                angle={-45}
                                                textAnchor="end"
                                                height={60}
                                                interval={walletHistoryData.length > 14 ? Math.floor(walletHistoryData.length / 14) : 0}
                                            />
                                            <YAxis
                                                stroke={styles.axisStroke}
                                                tick={{ fill: styles.axisTick, fontSize: 10 }}
                                                tickFormatter={(v) => '₹' + v.toLocaleString('en-IN')}
                                                label={{
                                                    value: 'Balance (₹)',
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: { fill: styles.axisTick, fontSize: 11 }
                                                }}
                                            />
                                            <Tooltip content={<WalletBalanceTooltip />} />
                                            <Legend
                                                wrapperStyle={{ fontSize: '11px', paddingTop: '10px' }}
                                                formatter={(value) => <span className={`text-xs sm:text-sm ${styles.textAccent}`}>{value}</span>}
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="totalAmount"
                                                stroke="#34d399"
                                                strokeWidth={2}
                                                name="Balance"
                                                dot={{ r: 3, fill: "#34d399", strokeWidth: 1.5 }}
                                                activeDot={{ r: 5, fill: "#34d399", stroke: isDark ? "#0f172a" : "#ffffff", strokeWidth: 1.5 }}
                                                fillOpacity={0.3}
                                                fill="url(#walletGradient)"
                                            />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>

                                {/* Recent Transactions Table */}
                                {walletStats.recentTransactions.length > 0 && (
                                <div className={`p-2 mt-4 overflow-x-auto sm:p-4 sm:mt-6 ${styles.innerBgAlt}`}>
                                    <h3 className={`mb-3 text-sm font-semibold sm:text-base md:text-lg ${styles.textPrimary}`}>Balance History</h3>
                                    <div className="overflow-x-auto">
                                    <div className="max-h-[245px] overflow-y-auto relative">
                                        <table className="min-w-[500px] w-full border-collapse sm:min-w-full">
                                        <thead className="sticky top-0 z-10">
                                            <tr className={`border-b ${styles.borderSoft} ${styles.innerBgAlt}`}>
                                            <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left whitespace-nowrap sm:px-3 sm:text-sm ${styles.textMuted}`}>Date</th>
                                            <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left whitespace-nowrap sm:px-3 sm:text-sm ${styles.textMuted}`}>Total Users</th>
                                            <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left whitespace-nowrap sm:px-3 sm:text-sm ${styles.textMuted}`}>Subtracted Amount</th>
                                            <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left whitespace-nowrap sm:px-3 sm:text-sm ${styles.textMuted}`}>Current Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {walletStats.recentTransactions.map((transaction, idx) => (
                                            <tr
                                                key={idx}
                                                className={`border-b ${styles.borderSoft} ${styles.rowHover} transition-colors ${
                                                idx % 2 === 0 ? styles.innerBgAlt : ''
                                                }`}
                                            >
                                                <td className={`px-2 py-2 text-xs whitespace-nowrap sm:px-3 sm:py-3 ${isDark ? 'text-gray-200' : 'text-slate-700'}`}>
                                                {new Date(transaction.DateString).toLocaleDateString("en-IN", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric"
                                                })}
                                                </td>
                                                <td className={`px-2 py-2 text-xs whitespace-nowrap sm:px-3 sm:py-3 ${styles.textMuted}`}>
                                                {transaction.subtractamount || transaction.orgId?.totalUsers || 0}
                                                </td>
                                                <td className="px-2 py-2 text-xs text-red-400 whitespace-nowrap sm:px-3 sm:py-3">
                                                -₹{(transaction.subtractamount || 0).toLocaleString('en-IN')}
                                                </td>
                                                <td className="px-2 py-2 text-xs font-medium text-green-500 whitespace-nowrap sm:px-3 sm:py-3">
                                                ₹{(transaction.totalamount || 0).toLocaleString('en-IN')}
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>
                                        </table>

                                        {/* Scroll Indicator */}
                                        {walletStats.recentTransactions.length > 5 && (
                                        <div className={`absolute bottom-0 left-0 right-0 h-8 pointer-events-none bg-gradient-to-t to-transparent ${isDark ? 'from-[#0B0F1C]' : 'from-white'}`}></div>
                                        )}
                                    </div>

                                    {/* Scroll Hint for Mobile */}
                                    {walletStats.recentTransactions.length > 3 && (
                                        <div className="mt-2 text-center sm:mt-3">
                                        <p className={`text-[10px] flex items-center justify-center gap-1 sm:text-xs ${isDark ? 'text-blue-400/60' : 'text-blue-400'}`}>
                                            <svg className="w-2 h-2 animate-bounce sm:w-3 sm:h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                            </svg>
                                            Scroll for more
                                            <svg className="w-2 h-2 animate-bounce sm:w-3 sm:h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                            </svg>
                                        </p>
                                        </div>
                                    )}
                                    </div>
                                </div>
                                )}
                            </>
                        ) : (
                            <div className="flex flex-col items-center justify-center h-48 space-y-2 sm:h-64">
                                <Wallet className={`w-8 h-8 sm:w-10 sm:h-10 ${isDark ? 'text-blue-700' : 'text-blue-200'}`} />
                                <p className={`text-sm text-center sm:text-base ${styles.textMuted}`}>No wallet data available for selected date range</p>
                                <button
                                    onClick={() => fetchWalletBalance(dispatch, setLoading)}
                                    className={`px-3 py-1.5 mt-2 text-xs transition-colors rounded-lg sm:px-4 sm:py-2 sm:text-sm ${styles.refreshBtn}`}
                                >
                                    Load Wallet Data
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {/* Device List Table */}
                <div className={`p-4 border sm:p-6 backdrop-blur-sm rounded-2xl ${styles.cardBg}`}>
                    <div className="flex items-center justify-between mb-4 sm:mb-6">
                        <h2 className={`text-base font-semibold sm:text-lg lg:text-xl ${styles.textPrimary}`}>Device Activity</h2>
                        <HardDrive className={`w-4 h-4 sm:w-5 sm:h-5 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                    </div>
                    {deviceActivity.length > 0 ? (
                        <div className="overflow-x-auto">
                            <table className="min-w-[600px] w-full sm:min-w-full">
                                <thead>
                                    <tr className={`border-b ${styles.borderSoft} ${styles.innerBgAlt}`}>
                                        <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>Device Name</th>
                                        <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>Location</th>
                                        <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>Users Count</th>
                                        <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>Status</th>
                                        <th className={`px-2 py-2 text-xs font-bold tracking-wider text-left sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>Last Seen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {deviceActivity.map((device, index) => (
                                        <tr key={index} className={`transition-colors border-b ${styles.borderSoft} ${styles.rowHover}`}>
                                            <td className="px-2 py-2 sm:px-4 sm:py-3">
                                                <div className="flex items-center space-x-1 sm:space-x-3">
                                                    <Monitor className={`w-3 h-3 sm:w-4 sm:h-4 ${isDark ? 'text-blue-400' : 'text-blue-500'}`} />
                                                    <span className={`text-xs sm:text-sm ${styles.textPrimary}`}>{device.name}</span>
                                                </div>
                                            </td>
                                            <td className={`px-2 py-2 text-xs sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>{device.location}</td>
                                            <td className="px-2 py-2 sm:px-4 sm:py-3">
                                                <span className={`px-1.5 py-0.5 text-xs rounded-full sm:px-2 sm:py-1 sm:text-sm ${styles.innerBg} ${styles.textMuted}`}>
                                                    {device.users}
                                                </span>
                                            </td>
                                            <td className="px-2 py-2 sm:px-4 sm:py-3">
                                                <span className={`flex items-center space-x-1 text-xs sm:text-sm ${device.status === 'ONLINE' || device.status === 'HEARTBEAT' ? 'text-green-500' : 'text-red-500'}`}>
                                                    {device.status === 'ONLINE' || device.status === 'HEARTBEAT' ? (
                                                        <Wifi className="w-3 h-3 sm:w-4 sm:h-4" />
                                                    ) : (
                                                        <WifiOff className="w-3 h-3 sm:w-4 sm:h-4" />
                                                    )}
                                                    <span>{device.status}</span>
                                                </span>
                                            </td>
                                            <td className={`px-2 py-2 text-xs sm:px-4 sm:py-3 sm:text-sm ${styles.textMuted}`}>
                                                {new Date(device.last_seen).toLocaleString()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="py-6 text-center sm:py-8">
                            <p className={`text-sm sm:text-base ${styles.textMuted}`}>No device data available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const STAT_ACCENTS = {
    blue:   { iconBgLight: 'bg-blue-50/10',   iconTextLight: 'text-blue-600',   iconBgDark: 'bg-blue-400/50' },
    purple: { iconBgLight: 'bg-purple-100/60', iconTextLight: 'text-purple-600', iconBgDark: 'bg-purple-500/20' },
    indigo: { iconBgLight: 'bg-yellow-100/20', iconTextLight: 'text-yellow-600', iconBgDark: 'bg-yellow-400/30' },
    green:  { iconBgLight: 'bg-green-100/70',  iconTextLight: 'text-green-600',  iconBgDark: 'bg-green-500/20' },
    pink:   { iconBgLight: 'bg-pink-100/20',   iconTextLight: 'text-pink-600',   iconBgDark: 'bg-pink-400/40' },
};

const StatCard = ({ icon: Icon, title, value, accent = 'blue', isDark, children }) => {
    const a = STAT_ACCENTS[accent] || STAT_ACCENTS.blue;

    if (isDark) {
        return (
            <div className="p-4 shadow-lg bg-gradient-to-br from-blue-600 to-blue-800 rounded-xl sm:p-6">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs text-blue-100 sm:text-sm">{title}</p>
                        <p className="mt-1 text-xl font-bold text-white sm:text-2xl lg:text-3xl">{value}</p>
                    </div>
                    <div className={`p-2 ${a.iconBgDark} rounded-xl sm:p-3`}>
                        <Icon className="w-4 h-4 text-white sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
                    </div>
                </div>
                {children}
            </div>
        );
    }

    return (
        <div className="p-4 border shadow-sm bg-gray-50 border-slate-1300 rounded-xl sm:p-6">
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-xs text-slate-500 sm:text-sm">{title}</p>
                    <p className="mt-1 text-xl font-bold text-slate-900 sm:text-2xl lg:text-3xl">{value}</p>
                </div>
                <div className={`p-2 ${a.iconBgLight} rounded-xl sm:p-3`}>
                    <Icon className={`w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 ${a.iconTextLight}`} />
                </div>
            </div>
            {children}
        </div>
    );
};

export default OverviewDashboard;
